var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGa6VDC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 600,
    viewBox: "0.0 0.0 800.000 600.000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Produce by Acme CAD Converter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Produce by Acme CAD Converter")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M797.74 2.86L797.74 597.14",
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26 2.86L2.26 597.14",
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327.03 140.76L327.23 135.43M327.23 135.43L327.83 130.13M327.83 130.13L328.82 124.89M328.82 124.89L330.2 119.74M330.2 119.74L331.96 114.71M331.96 114.71L334.09 109.82M334.09 109.82L336.58 105.1M336.58 105.1L339.42 100.59M339.42 100.59L342.59 96.3M342.59 96.3L346.06 92.26M346.06 92.26L349.83 88.49M349.83 88.49L353.88 85.01M353.88 85.01L358.17 81.84M358.17 81.84L362.68 79.01M362.68 79.01L367.4 76.51M367.4 76.51L372.28 74.38M372.28 74.38L377.32 72.62M377.32 72.62L382.47 71.24M382.47 71.24L387.71 70.25M387.71 70.25L393 69.65M393 69.65L398.33 69.45M398.33 69.45L403.66 69.65M403.66 69.65L408.96 70.25M408.96 70.25L414.2 71.24M414.2 71.24L419.35 72.62M419.35 72.62L424.38 74.38M424.38 74.38L429.27 76.51M429.27 76.51L433.98 79.01M433.98 79.01L438.5 81.84M438.5 81.84L442.79 85.01M442.79 85.01L446.83 88.49M446.83 88.49L450.6 92.26M450.6 92.26L454.08 96.3M454.08 96.3L457.25 100.59M457.25 100.59L460.08 105.1M460.08 105.1L462.58 109.82M462.58 109.82L464.71 114.71M464.71 114.71L466.47 119.74M466.47 119.74L467.85 124.89M467.85 124.89L468.84 130.13M468.84 130.13L469.44 135.43M469.44 135.43L469.64 140.76M469.64 140.76L469.44 146.08M469.44 146.08L468.84 151.38M468.84 151.38L467.85 156.62M467.85 156.62L466.47 161.77M466.47 161.77L464.71 166.81M464.71 166.81L462.58 171.69M462.58 171.69L460.08 176.41M460.08 176.41L457.25 180.92M457.25 180.92L454.08 185.21M454.08 185.21L450.6 189.25M450.6 189.25L446.83 193.03M446.83 193.03L442.79 196.5M442.79 196.5L438.5 199.67M438.5 199.67L433.98 202.51M433.98 202.51L429.27 205M429.27 205L424.38 207.13M424.38 207.13L419.35 208.89M419.35 208.89L414.2 210.27M414.2 210.27L408.96 211.26M408.96 211.26L403.66 211.86M403.66 211.86L398.33 212.06M398.33 212.06L393 211.86M393 211.86L387.71 211.26M387.71 211.26L382.47 210.27M382.47 210.27L377.32 208.89M377.32 208.89L372.28 207.13M372.28 207.13L367.4 205M367.4 205L362.68 202.51M362.68 202.51L358.17 199.67M358.17 199.67L353.88 196.5M353.88 196.5L349.83 193.03M349.83 193.03L346.06 189.25M346.06 189.25L342.59 185.21M342.59 185.21L339.42 180.92M339.42 180.92L336.58 176.41M336.58 176.41L334.09 171.69M334.09 171.69L331.96 166.81M331.96 166.81L330.2 161.77M330.2 161.77L328.82 156.62M328.82 156.62L327.83 151.38M327.83 151.38L327.23 146.08M327.23 146.08L327.03 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26 597.14L797.74 597.14",
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.65 229.41L350.84 227.76M350.84 227.76L351.39 226.19M351.39 226.19L352.27 224.79M352.27 224.79L353.44 223.62M353.44 223.62L354.84 222.74M354.84 222.74L356.41 222.19M356.41 222.19L358.06 222M358.06 222L359.7 222.19M359.7 222.19L361.27 222.74M361.27 222.74L362.67 223.62M362.67 223.62L363.84 224.79M363.84 224.79L364.73 226.19M364.73 226.19L365.27 227.76M365.27 227.76L365.46 229.41M365.46 229.41L365.27 231.05M365.27 231.05L364.73 232.62M364.73 232.62L363.84 234.02M363.84 234.02L362.67 235.19M362.67 235.19L361.27 236.08M361.27 236.08L359.7 236.62M359.7 236.62L358.06 236.81M358.06 236.81L356.41 236.62M356.41 236.62L354.84 236.08M354.84 236.08L353.44 235.19M353.44 235.19L352.27 234.02M352.27 234.02L351.39 232.62M351.39 232.62L350.84 231.05M350.84 231.05L350.65 229.41",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.21 225.77L356.62 228.73M356.62 228.73L357.21 228.13M357.21 228.13L358.1 227.84M358.1 227.84L358.99 227.84M358.99 227.84L359.87 228.13M359.87 228.13L360.46 228.73M360.46 228.73L360.76 229.61M360.76 229.61L360.76 230.2M360.76 230.2L360.46 231.09M360.46 231.09L359.87 231.68M359.87 231.68L358.99 231.97M358.99 231.97L358.1 231.97M358.1 231.97L357.21 231.68M357.21 231.68L356.92 231.38M356.92 231.38L356.62 230.79M356.62 230.79L356.62 230.5M356.62 230.5L356.92 230.2M356.92 230.2L357.21 230.5M357.21 230.5L356.92 230.79M358.99 227.84L359.58 228.13M359.58 228.13L360.17 228.73M360.17 228.73L360.46 229.61M360.46 229.61L360.46 230.2M360.46 230.2L360.17 231.09M360.17 231.09L359.58 231.68M359.58 231.68L358.99 231.97M357.21 225.77L360.17 225.77M357.21 226.07L358.69 226.07M358.69 226.07L360.17 225.77",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.62 205.74L301.8 204.1M301.8 204.1L302.35 202.53M302.35 202.53L303.23 201.13M303.23 201.13L304.41 199.95M304.41 199.95L305.81 199.07M305.81 199.07L307.37 198.53M307.37 198.53L309.02 198.34M309.02 198.34L310.67 198.53M310.67 198.53L312.23 199.07M312.23 199.07L313.64 199.95M313.64 199.95L314.81 201.13M314.81 201.13L315.69 202.53M315.69 202.53L316.24 204.1M316.24 204.1L316.42 205.74M316.42 205.74L316.24 207.39M316.24 207.39L315.69 208.96M315.69 208.96L314.81 210.36M314.81 210.36L313.64 211.53M313.64 211.53L312.23 212.41M312.23 212.41L310.67 212.96M310.67 212.96L309.02 213.15M309.02 213.15L307.37 212.96M307.37 212.96L305.81 212.41M305.81 212.41L304.41 211.53M304.41 211.53L303.23 210.36M303.23 210.36L302.35 208.96M302.35 208.96L301.8 207.39M301.8 207.39L301.62 205.74",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M310.29 203.08L310.29 208.69M310.58 202.49L310.58 208.69M310.58 202.49L307.33 206.92M307.33 206.92L312.06 206.92M309.4 208.69L311.47 208.69",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M486.68 205.66L486.87 204.01M486.87 204.01L487.42 202.45M487.42 202.45L488.3 201.05M488.3 201.05L489.47 199.87M489.47 199.87L490.88 198.99M490.88 198.99L492.44 198.44M492.44 198.44L494.09 198.26M494.09 198.26L495.74 198.44M495.74 198.44L497.3 198.99M497.3 198.99L498.7 199.87M498.7 199.87L499.88 201.05M499.88 201.05L500.76 202.45M500.76 202.45L501.31 204.01M501.31 204.01L501.49 205.66M501.49 205.66L501.31 207.31M501.31 207.31L500.76 208.87M500.76 208.87L499.88 210.28M499.88 210.28L498.7 211.45M498.7 211.45L497.3 212.33M497.3 212.33L495.74 212.88M495.74 212.88L494.09 213.07M494.09 213.07L492.44 212.88M492.44 212.88L490.88 212.33M490.88 212.33L489.47 211.45M489.47 211.45L488.3 210.28M488.3 210.28L487.42 208.87M487.42 208.87L486.87 207.31M486.87 207.31L486.68 205.66",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M492.7 203.59L492.99 203.88M492.99 203.88L492.7 204.18M492.7 204.18L492.4 203.88M492.4 203.88L492.4 203.59M492.4 203.59L492.7 203M492.7 203L492.99 202.7M492.99 202.7L493.88 202.41M493.88 202.41L495.06 202.41M495.06 202.41L495.94 202.7M495.94 202.7L496.24 203.29M496.24 203.29L496.24 204.18M496.24 204.18L495.94 204.77M495.94 204.77L495.06 205.07M495.06 205.07L494.17 205.07M495.06 202.41L495.65 202.7M495.65 202.7L495.94 203.29M495.94 203.29L495.94 204.18M495.94 204.18L495.65 204.77M495.65 204.77L495.06 205.07M495.06 205.07L495.65 205.36M495.65 205.36L496.24 205.95M496.24 205.95L496.53 206.54M496.53 206.54L496.53 207.43M496.53 207.43L496.24 208.02M496.24 208.02L495.94 208.31M495.94 208.31L495.06 208.61M495.06 208.61L493.88 208.61M493.88 208.61L492.99 208.31M492.99 208.31L492.7 208.02M492.7 208.02L492.4 207.43M492.4 207.43L492.4 207.13M492.4 207.13L492.7 206.84M492.7 206.84L492.99 207.13M492.99 207.13L492.7 207.43M495.94 205.66L496.24 206.54M496.24 206.54L496.24 207.43M496.24 207.43L495.94 208.02M495.94 208.02L495.65 208.31M495.65 208.31L495.06 208.61",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26 2.86L797.74 2.86",
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 2.86L82.5 32.34",
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59 11L9.59 24.64M10.24 11.65L10.24 23.99M10.89 11L10.89 24.64M7.65 11L18.04 11M18.04 11L18.04 14.9M10.89 17.5L14.79 17.5M14.79 14.9L14.79 20.09M7.65 24.64L18.04 24.64M18.04 24.64L18.04 20.74M8.3 11L9.59 11.65M8.94 11L9.59 12.3M11.54 11L10.89 12.3M12.19 11L10.89 11.65M14.79 11L18.04 11.65M16.09 11L18.04 12.3M16.74 11L18.04 12.95M17.39 11L18.04 14.9M14.79 14.9L14.14 17.5M14.14 17.5L14.79 20.09M14.79 16.2L13.49 17.5M13.49 17.5L14.79 18.79M14.79 16.85L12.19 17.5M12.19 17.5L14.79 18.14M9.59 23.99L8.3 24.64M9.59 23.34L8.94 24.64M10.89 23.34L11.54 24.64M10.89 23.99L12.19 24.64M14.79 24.64L18.04 23.99M16.09 24.64L18.04 23.34M16.74 24.64L18.04 22.69M17.39 24.64L18.04 20.74M23.23 11L23.23 23.99M23.23 11L32.33 24.64M23.88 11L31.68 22.69M24.53 11L32.33 22.69M32.33 11.65L32.33 24.64M21.29 11L24.53 11M30.38 11L34.28 11M21.29 24.64L25.18 24.64M21.94 11L23.23 11.65M31.03 11L32.33 11.65M33.63 11L32.33 11.65M23.23 23.99L21.94 24.64M23.23 23.99L24.53 24.64M46.62 12.95L47.27 11M47.27 11L47.27 14.9M47.27 14.9L46.62 12.95M46.62 12.95L45.32 11.65M45.32 11.65L44.02 11M44.02 11L42.07 11M42.07 11L40.12 11.65M40.12 11.65L38.82 12.95M38.82 12.95L38.17 14.25M38.17 14.25L37.53 16.2M37.53 16.2L37.53 19.44M37.53 19.44L38.17 21.39M38.17 21.39L38.82 22.69M38.82 22.69L40.12 23.99M40.12 23.99L42.07 24.64M42.07 24.64L44.02 24.64M44.02 24.64L45.32 23.99M45.32 23.99L46.62 22.69M46.62 22.69L47.27 21.39M39.47 12.95L38.82 14.25M38.82 14.25L38.17 16.2M38.17 16.2L38.17 19.44M38.17 19.44L38.82 21.39M38.82 21.39L39.47 22.69M42.07 11L40.77 11.65M40.77 11.65L39.47 13.6M39.47 13.6L38.82 16.2M38.82 16.2L38.82 19.44M38.82 19.44L39.47 22.04M39.47 22.04L40.77 23.99M40.77 23.99L42.07 24.64M55.71 11L53.76 11.65M53.76 11.65L52.46 12.95M52.46 12.95L51.82 14.25M51.82 14.25L51.17 16.85M51.17 16.85L51.17 18.79M51.17 18.79L51.82 21.39M51.82 21.39L52.46 22.69M52.46 22.69L53.76 23.99M53.76 23.99L55.71 24.64M55.71 24.64L57.01 24.64M57.01 24.64L58.96 23.99M58.96 23.99L60.26 22.69M60.26 22.69L60.91 21.39M60.91 21.39L61.56 18.79M61.56 18.79L61.56 16.85M61.56 16.85L60.91 14.25M60.91 14.25L60.26 12.95M60.26 12.95L58.96 11.65M58.96 11.65L57.01 11M57.01 11L55.71 11M53.11 12.95L52.46 14.25M52.46 14.25L51.82 16.2M51.82 16.2L51.82 19.44M51.82 19.44L52.46 21.39M52.46 21.39L53.11 22.69M59.61 22.69L60.26 21.39M60.26 21.39L60.91 19.44M60.91 19.44L60.91 16.2M60.91 16.2L60.26 14.25M60.26 14.25L59.61 12.95M55.71 11L54.41 11.65M54.41 11.65L53.11 13.6M53.11 13.6L52.46 16.2M52.46 16.2L52.46 19.44M52.46 19.44L53.11 22.04M53.11 22.04L54.41 23.99M54.41 23.99L55.71 24.64M57.01 24.64L58.31 23.99M58.31 23.99L59.61 22.04M59.61 22.04L60.26 19.44M60.26 19.44L60.26 16.2M60.26 16.2L59.61 13.6M59.61 13.6L58.31 11.65M58.31 11.65L57.01 11M66.76 11L66.76 23.99M66.76 11L75.85 24.64M67.4 11L75.2 22.69M68.05 11L75.85 22.69M75.85 11.65L75.85 24.64M64.81 11L68.05 11M73.9 11L77.8 11M64.81 24.64L68.7 24.64M65.46 11L66.76 11.65M74.55 11L75.85 11.65M77.15 11L75.85 11.65M66.76 23.99L65.46 24.64M66.76 23.99L68.05 24.64",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26 32.34L82.5 32.34",
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M423.06 140.76L423.04 139.77M423.04 139.77L422.98 138.78M422.98 138.78L422.88 137.79M422.88 137.79L422.74 136.82M422.74 136.82L422.74 136.79M422.34 134.84L422.09 133.92M422.09 133.92L421.8 132.97M421.8 132.97L421.47 132.04M421.47 132.04L421.1 131.12M421.1 131.12L421.08 131.07M420.22 129.27L419.79 128.47M419.79 128.47L419.28 127.62M419.28 127.62L418.73 126.79M418.73 126.79L418.16 125.98M418.16 125.98L418.1 125.9M416.84 124.36L416.25 123.72M416.25 123.72L415.55 123.01M415.55 123.01L414.83 122.34M414.83 122.34L414.08 121.69M414.08 121.69L413.97 121.61M412.38 120.41L411.68 119.94M411.68 119.94L410.84 119.43M410.84 119.43L409.97 118.94M409.97 118.94L409.09 118.5M409.09 118.5L408.93 118.42M407.1 117.64L406.35 117.37M406.35 117.37L405.41 117.07M405.41 117.07L404.45 116.8M404.45 116.8L403.49 116.58M403.49 116.58L403.28 116.53M401.31 116.22L400.56 116.13M400.56 116.13L399.57 116.06M399.57 116.06L398.58 116.03M398.58 116.03L397.59 116.04M397.59 116.04L397.34 116.06M395.35 116.22L394.64 116.31M394.64 116.31L393.66 116.48M393.66 116.48L392.69 116.68M392.69 116.68L391.74 116.93M391.74 116.93L391.46 117.01M389.57 117.64L388.93 117.89M388.93 117.89L388.02 118.28M388.02 118.28L387.13 118.72M387.13 118.72L386.26 119.18M386.26 119.18L385.97 119.35M384.29 120.41L383.76 120.78M383.76 120.78L382.97 121.38M382.97 121.38L382.21 122.01M382.21 122.01L381.47 122.67M381.47 122.67L381.21 122.93M379.83 124.36L379.43 124.82M379.43 124.82L378.81 125.59M378.81 125.59L378.22 126.38M378.22 126.38L377.66 127.2M377.66 127.2L377.44 127.54M376.45 129.27L376.18 129.77M376.18 129.77L375.76 130.67M375.76 130.67L375.37 131.58M375.37 131.58L375.03 132.51M375.03 132.51L374.89 132.93M374.33 134.84L374.21 135.36M374.21 135.36L374.01 136.33M374.01 136.33L373.85 137.3M373.85 137.3L373.73 138.29M373.73 138.29L373.69 138.77M373.61 140.76L373.61 141.25M373.61 141.25L373.65 142.24M373.65 142.24L373.73 143.23M373.73 143.23L373.85 144.21M373.85 144.21L373.93 144.72M374.33 146.67L374.44 147.12M374.44 147.12L374.71 148.07M374.71 148.07L375.03 149.01M375.03 149.01L375.37 149.93M375.37 149.93L375.59 150.45M376.45 152.24L376.64 152.62M376.64 152.62L377.13 153.47M377.13 153.47L377.66 154.31M377.66 154.31L378.22 155.13M378.22 155.13L378.57 155.61M379.83 157.15L380.08 157.43M380.08 157.43L380.76 158.15M380.76 158.15L381.47 158.84M381.47 158.84L382.21 159.5M382.21 159.5L382.7 159.9M384.29 161.1L384.57 161.3M384.57 161.3L385.4 161.83M385.4 161.83L386.26 162.33M386.26 162.33L387.13 162.8M387.13 162.8L387.74 163.09M389.57 163.87L389.85 163.98M389.85 163.98L390.79 164.3M390.79 164.3L391.74 164.58M391.74 164.58L392.69 164.83M392.69 164.83L393.39 164.98M395.35 165.3L395.62 165.33M395.62 165.33L396.6 165.42M396.6 165.42L397.59 165.47M397.59 165.47L398.58 165.48M398.58 165.48L399.33 165.46M401.31 165.3L401.54 165.27M401.54 165.27L402.52 165.12M402.52 165.12L403.49 164.94M403.49 164.94L404.45 164.71M404.45 164.71L405.21 164.5M407.1 163.87L407.28 163.81M407.28 163.81L408.19 163.43M408.19 163.43L409.09 163.02M409.09 163.02L409.97 162.57M409.97 162.57L410.69 162.17M412.38 161.1L412.5 161.02M412.5 161.02L413.3 160.43M413.3 160.43L414.08 159.82M414.08 159.82L414.83 159.17M414.83 159.17L415.46 158.59M416.84 157.15L416.92 157.07M416.92 157.07L417.55 156.31M417.55 156.31L418.16 155.53M418.16 155.53L418.73 154.72M418.73 154.72L419.23 153.97M420.22 152.25L420.26 152.18M420.26 152.18L420.7 151.29M420.7 151.29L421.1 150.39M421.1 150.39L421.47 149.47M421.47 149.47L421.78 148.59M422.34 146.67L422.35 146.64M422.35 146.64L422.56 145.67M422.56 145.67L422.74 144.7M422.74 144.7L422.88 143.72M422.88 143.72L422.98 142.75",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M419.76 140.76L419.74 139.83M419.74 139.83L419.68 138.91M419.68 138.91L419.58 138M419.58 138L419.44 137.09M419.44 137.09L419.27 136.18M419.27 136.18L419.05 135.28M419.05 135.28L418.8 134.4M418.8 134.4L418.5 133.52M418.5 133.52L418.17 132.66M418.17 132.66L417.81 131.82M417.81 131.82L417.4 130.99M417.4 130.99L416.97 130.18M416.97 130.18L416.49 129.38M416.49 129.38L415.99 128.61M415.99 128.61L415.45 127.86M415.45 127.86L414.88 127.14M414.88 127.14L414.28 126.44M414.28 126.44L413.65 125.77M413.65 125.77L412.99 125.12M412.99 125.12L412.3 124.51M412.3 124.51L411.59 123.92M411.59 123.92L410.85 123.37M410.85 123.37L410.24 122.94M406.53 120.96L406 120.75M406 120.75L405.13 120.43M405.13 120.43L404.25 120.16M404.25 120.16L403.36 119.93M403.36 119.93L402.51 119.74M398.33 119.33L397.87 119.33M397.87 119.33L396.95 119.37M396.95 119.37L396.03 119.45M396.03 119.45L395.12 119.57M395.12 119.57L394.21 119.73M394.21 119.73L393.31 119.93M393.31 119.93L392.42 120.16M392.42 120.16L391.54 120.43M391.54 120.43L390.67 120.75M390.67 120.75L389.81 121.09M389.81 121.09L388.98 121.48M388.98 121.48L388.16 121.9M388.16 121.9L387.35 122.35M387.35 122.35L386.57 122.84M386.57 122.84L385.81 123.37M385.81 123.37L385.08 123.92M385.08 123.92L384.36 124.51M384.36 124.51L383.68 125.12M383.68 125.12L383.02 125.77M383.02 125.77L382.39 126.44M382.39 126.44L381.79 127.14M381.79 127.14L381.22 127.86M381.22 127.86L380.68 128.61M380.68 128.61L380.52 128.85M378.54 132.56L378.49 132.66M378.49 132.66L378.16 133.52M378.16 133.52L377.87 134.4M377.87 134.4L377.62 135.28M377.62 135.28L377.4 136.18M377.4 136.18L377.32 136.58M376.91 140.76L376.93 141.68M376.93 141.68L376.98 142.6M376.98 142.6L377.08 143.51M377.08 143.51L377.22 144.43M377.22 144.43L377.4 145.33M377.4 145.33L377.62 146.23M377.62 146.23L377.87 147.11M377.87 147.11L378.16 147.99M378.16 147.99L378.49 148.85M378.49 148.85L378.86 149.7M378.86 149.7L379.26 150.53M379.26 150.53L379.7 151.34M379.7 151.34L380.17 152.13M380.17 152.13L380.68 152.9M380.68 152.9L381.22 153.65M381.22 153.65L381.79 154.37M381.79 154.37L382.39 155.07M382.39 155.07L383.02 155.74M383.02 155.74L383.68 156.39M383.68 156.39L384.36 157M384.36 157L385.08 157.59M385.08 157.59L385.81 158.15M385.81 158.15L386.43 158.57M390.13 160.55L390.67 160.77M390.67 160.77L391.54 161.08M391.54 161.08L392.42 161.35M392.42 161.35L393.31 161.59M393.31 161.59L394.15 161.77M398.33 162.18L398.79 162.18M398.79 162.18L399.72 162.14M399.72 162.14L400.63 162.06M400.63 162.06L401.55 161.94M401.55 161.94L402.46 161.78M402.46 161.78L403.36 161.59M403.36 161.59L404.25 161.35M404.25 161.35L405.13 161.08M405.13 161.08L406 160.77M406 160.77L406.85 160.42M406.85 160.42L407.69 160.03M407.69 160.03L408.51 159.61M408.51 159.61L409.31 159.16M409.31 159.16L410.09 158.67M410.09 158.67L410.85 158.15M410.85 158.15L411.59 157.59M411.59 157.59L412.3 157M412.3 157L412.99 156.39M412.99 156.39L413.65 155.74M413.65 155.74L414.28 155.07M414.28 155.07L414.88 154.37M414.88 154.37L415.45 153.65M415.45 153.65L415.99 152.9M415.99 152.9L416.15 152.66M418.13 148.96L418.17 148.85M418.17 148.85L418.5 147.99M418.5 147.99L418.8 147.11M418.8 147.11L419.05 146.23M419.05 146.23L419.27 145.33M419.27 145.33L419.34 144.94",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M395.97 133.73L394.46 134.43M394.46 134.43L393.14 135.46M393.14 135.46L392.09 136.75M392.09 136.75L391.35 138.25M391.35 138.25L390.97 139.87M390.97 139.87L390.96 141.54M390.96 141.54L391.32 143.17M391.32 143.17L392.04 144.67M392.04 144.67L393.07 145.98M393.07 145.98L394.37 147.03M394.37 147.03L395.87 147.75M395.87 147.75L397.5 148.13M397.5 148.13L399.17 148.13M399.17 148.13L400.79 147.75M400.79 147.75L402.3 147.03M402.3 147.03L403.6 145.98M403.6 145.98L404.63 144.67M404.63 144.67L405.35 143.17M405.35 143.17L405.71 141.54M405.71 141.54L405.7 139.87M405.7 139.87L405.31 138.25M405.31 138.25L404.58 136.75M404.58 136.75L403.52 135.46M403.52 135.46L402.21 134.43M402.21 134.43L400.7 133.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M381.85 140.76L382.04 138.24M382.04 138.24L382.62 135.78M382.62 135.78L383.56 133.44M383.56 133.44L384.85 131.27M384.85 131.27L386.46 129.33M386.46 129.33L388.34 127.65M388.34 127.65L390.46 126.28M390.46 126.28L392.76 125.24M392.76 125.24L395.2 124.57M395.2 124.57L397.7 124.29M397.7 124.29L400.22 124.38M400.22 124.38L402.7 124.86M402.7 124.86L405.08 125.72M405.08 125.72L407.29 126.92M407.29 126.92L409.3 128.45M409.3 128.45L411.05 130.27M411.05 130.27L412.5 132.33M412.5 132.33L413.62 134.59M413.62 134.59L414.38 137M414.38 137L414.77 139.49M414.77 139.49L414.77 142.02M414.77 142.02L414.38 144.51M414.38 144.51L413.62 146.92M413.62 146.92L412.5 149.18M412.5 149.18L411.05 151.24M411.05 151.24L409.3 153.06M409.3 153.06L407.29 154.59M407.29 154.59L405.08 155.8M405.08 155.8L402.7 156.65M402.7 156.65L400.22 157.13M400.22 157.13L397.7 157.23M397.7 157.23L395.2 156.94M395.2 156.94L392.76 156.27M392.76 156.27L390.46 155.24M390.46 155.24L388.34 153.86M388.34 153.86L386.46 152.19M386.46 152.19L384.85 150.24M384.85 150.24L383.56 148.07M383.56 148.07L382.62 145.73M382.62 145.73L382.04 143.27M382.04 143.27L381.85 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M398.25 298.76L398.25 277.22M398.25 273.29L398.25 269.35M398.25 265.41L398.25 243.88",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M398.33 222.77L398.33 209.66M398.33 205.72L398.33 201.78M398.33 197.85L398.33 178.16M398.33 174.22L398.33 170.29M398.33 166.35L398.33 146.66M398.33 142.72L398.33 138.79M398.33 134.85L398.33 115.16M398.33 111.23L398.33 107.29M398.33 103.35L398.33 83.67M398.33 79.73L398.33 75.79M398.33 71.86L398.33 58.75",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.49 140.76L77.37 140.76M81.3 140.76L85.24 140.76M89.18 140.76L108.86 140.76M112.8 140.76L116.74 140.76M120.68 140.76L140.36 140.76M144.3 140.76L148.24 140.76M152.17 140.76L171.86 140.76M175.8 140.76L179.73 140.76M183.67 140.76L203.36 140.76M207.29 140.76L211.23 140.76M215.17 140.76L234.86 140.76M238.79 140.76L242.73 140.76M246.67 140.76L266.35 140.76M270.29 140.76L274.23 140.76M278.16 140.76L297.85 140.76M301.79 140.76L305.72 140.76M309.66 140.76L329.35 140.76M333.28 140.76L337.22 140.76M341.16 140.76L360.85 140.76M364.78 140.76L368.72 140.76M372.66 140.76L392.34 140.76M396.28 140.76L400.22 140.76M404.15 140.76L423.84 140.76M427.78 140.76L431.71 140.76M435.65 140.76L455.34 140.76M459.28 140.76L463.21 140.76M467.15 140.76L486.84 140.76M490.77 140.76L494.71 140.76M498.65 140.76L518.33 140.76M522.27 140.76L526.21 140.76M530.14 140.76L549.83 140.76M553.77 140.76L557.7 140.76M561.64 140.76L581.33 140.76M585.27 140.76L589.2 140.76M593.14 140.76L612.83 140.76M616.76 140.76L620.7 140.76M624.64 140.76L644.32 140.76M648.26 140.76L652.2 140.76M656.13 140.76L675.82 140.76M679.76 140.76L683.7 140.76M687.63 140.76L707.32 140.76M711.26 140.76L715.19 140.76M719.13 140.76L743 140.76",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M503.51 205.72L503.69 204.07M503.69 204.07L504.24 202.51M504.24 202.51L505.12 201.11M505.12 201.11L506.29 199.93M506.29 199.93L507.7 199.05M507.7 199.05L509.26 198.5M509.26 198.5L510.91 198.32M510.91 198.32L512.56 198.5M512.56 198.5L514.12 199.05M514.12 199.05L515.53 199.93M515.53 199.93L516.7 201.11M516.7 201.11L517.58 202.51M517.58 202.51L518.13 204.07M518.13 204.07L518.31 205.72M518.31 205.72L518.13 207.37M518.13 207.37L517.58 208.93M517.58 208.93L516.7 210.34M516.7 210.34L515.53 211.51M515.53 211.51L514.12 212.39M514.12 212.39L512.56 212.94M512.56 212.94L510.91 213.12M510.91 213.12L509.26 212.94M509.26 212.94L507.7 212.39M507.7 212.39L506.29 211.51M506.29 211.51L505.12 210.34M505.12 210.34L504.24 208.93M504.24 208.93L503.69 207.37M503.69 207.37L503.51 205.72",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M510.7 202.47L509.81 202.76M509.81 202.76L509.52 203.35M509.52 203.35L509.52 204.24M509.52 204.24L509.81 204.83M509.81 204.83L510.7 205.12M510.7 205.12L511.88 205.12M511.88 205.12L512.77 204.83M512.77 204.83L513.06 204.24M513.06 204.24L513.06 203.35M513.06 203.35L512.77 202.76M512.77 202.76L511.88 202.47M511.88 202.47L510.7 202.47M510.7 202.47L510.11 202.76M510.11 202.76L509.81 203.35M509.81 203.35L509.81 204.24M509.81 204.24L510.11 204.83M510.11 204.83L510.7 205.12M511.88 205.12L512.47 204.83M512.47 204.83L512.77 204.24M512.77 204.24L512.77 203.35M512.77 203.35L512.47 202.76M512.47 202.76L511.88 202.47M510.7 205.12L509.81 205.42M509.81 205.42L509.52 205.71M509.52 205.71L509.22 206.31M509.22 206.31L509.22 207.49M509.22 207.49L509.52 208.08M509.52 208.08L509.81 208.37M509.81 208.37L510.7 208.67M510.7 208.67L511.88 208.67M511.88 208.67L512.77 208.37M512.77 208.37L513.06 208.08M513.06 208.08L513.36 207.49M513.36 207.49L513.36 206.31M513.36 206.31L513.06 205.71M513.06 205.71L512.77 205.42M512.77 205.42L511.88 205.12M510.7 205.12L510.11 205.42M510.11 205.42L509.81 205.71M509.81 205.71L509.52 206.31M509.52 206.31L509.52 207.49M509.52 207.49L509.81 208.08M509.81 208.08L510.11 208.37M510.11 208.37L510.7 208.67M511.88 208.67L512.47 208.37M512.47 208.37L512.77 208.08M512.77 208.08L513.06 207.49M513.06 207.49L513.06 206.31M513.06 206.31L512.77 205.71M512.77 205.71L512.47 205.42M512.47 205.42L511.88 205.12",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M357.55 185.03L315.56 202.28",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M373.88 202.11L359.34 222.11",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M454.85 184.23L489.75 199.66",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M533.38 159.48L510.91 198.32",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M469.47 285.37L406.96 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M344.24 285.37L407.4 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M375.59 284.06L344.24 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M327.03 285.37L381.85 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M375.59 284.06L327.03 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M421.08 284.06L469.47 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M344.24 249.77L432.12 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M449.37 249.77L412.76 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M469.47 249.77L364.54 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M344.24 249.77L383.91 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M375.59 251.09L344.24 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M327.03 249.77L381.85 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M375.59 251.09L327.03 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M421.08 251.09L469.47 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M53.49 267.57L77.37 267.57M81.3 267.57L85.24 267.57M89.18 267.57L108.86 267.57M112.8 267.57L116.74 267.57M120.68 267.57L140.36 267.57M144.3 267.57L148.24 267.57M152.17 267.57L171.86 267.57M175.8 267.57L179.73 267.57M183.67 267.57L203.36 267.57M207.29 267.57L211.23 267.57M215.17 267.57L234.85 267.57M238.79 267.57L242.73 267.57M246.67 267.57L266.35 267.57M270.29 267.57L274.23 267.57M278.16 267.57L297.85 267.57M301.79 267.57L305.72 267.57M309.66 267.57L329.35 267.57M333.28 267.57L337.22 267.57M341.16 267.57L360.85 267.57M364.78 267.57L368.72 267.57M372.66 267.57L392.34 267.57M396.28 267.57L400.22 267.57M404.15 267.57L423.84 267.57M427.78 267.57L431.71 267.57M435.65 267.57L455.34 267.57M459.27 267.57L463.21 267.57M467.15 267.57L486.84 267.57M490.77 267.57L494.71 267.57M498.65 267.57L518.33 267.57M522.27 267.57L526.21 267.57M530.14 267.57L549.83 267.57M553.77 267.57L557.7 267.57M561.64 267.57L581.33 267.57M585.27 267.57L589.2 267.57M593.14 267.57L612.83 267.57M616.76 267.57L620.7 267.57M624.64 267.57L644.32 267.57M648.26 267.57L652.2 267.57M656.13 267.57L675.82 267.57M679.76 267.57L683.69 267.57M687.63 267.57L707.32 267.57M711.26 267.57L715.19 267.57M719.13 267.57L743 267.57",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M395.97 132.31L400.7 132.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M395.97 133.73L395.97 132.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M400.7 133.73L400.7 132.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M67.61 112.75L67.61 45.13",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M729.08 106.57L729.08 45.13",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M78.77 56.29L717.92 56.29",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M78.77 54.43L67.61 56.29 67.61 56.29 78.77 58.15 78.77 54.43Z",
    fillRule: "evenodd",
    fill: "lime"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M717.92 54.43L729.08 56.29 729.08 56.29 717.92 58.15 717.92 54.43Z",
    fillRule: "evenodd",
    fill: "lime"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M336.96 52.45L336.96 41.29M336.96 41.29L343.87 41.29M336.96 46.6L341.21 46.6M346.52 52.45L350.78 41.29M350.78 41.29L355.03 52.45M348.12 48.73L353.43 48.73M358.22 52.45L358.22 41.29M358.22 41.29L365.66 52.45M365.66 52.45L365.66 41.29M390.1 52.45L390.1 41.29M390.1 41.29L393.82 41.29M393.82 41.29L395.42 41.82M395.42 41.82L396.48 42.88M396.48 42.88L397.01 43.94M397.01 43.94L397.54 45.54M397.54 45.54L397.54 48.2M397.54 48.2L397.01 49.79M397.01 49.79L396.48 50.85M396.48 50.85L395.42 51.92M395.42 51.92L393.82 52.45M393.82 52.45L390.1 52.45M401.26 52.45L401.26 41.29M405.52 52.45L409.77 41.29M409.77 41.29L414.02 52.45M407.11 48.73L412.42 48.73M427.31 46.07L436.87 46.07M427.31 49.26L436.87 49.26M451.22 52.45L455.47 41.29M455.47 41.29L459.72 52.45M452.82 48.73L458.13 48.73",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.61 123.91L67.61 123.91",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M729.08 117.73L729.08 117.73",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M729.08 56.29L729.08 56.29",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37 251.65L371.93 251.09M371.37 253.5L373.35 251.52M372.33 254.39L373.35 253.37M375.99 252.58L377.48 251.09M376.03 254.39L379.33 251.09M379.61 250.81L380.65 249.77M377.88 254.39L382.5 249.77M379.47 254.65L384.35 249.77M379.61 256.36L386.2 249.77M379.61 258.21L388.05 249.77M379.61 260.06L388.59 251.08M379.61 261.91L388.53 252.99M379.61 263.76L388.47 254.9M379.61 265.61L388.41 256.82M379.61 267.46L388.34 258.73M379.61 269.31L381.35 267.57M379.61 271.16L383.2 267.57M381.35 267.57L388.28 260.64M383.2 267.57L388.22 262.55M371.37 281.25L371.86 280.76M379.61 273.01L385.05 267.57M385.05 267.57L388.15 264.47M371.37 283.1L373.35 281.12M379.61 274.86L386.9 267.57M386.9 267.57L388.09 266.38M372.27 284.06L373.35 282.97M379.61 276.71L388.03 268.29M375.99 282.19L377.41 280.76M379.61 278.56L387.97 270.21M407.88 250.3L408.4 249.77M375.99 284.04L387.9 272.12M407.94 252.09L410.25 249.77M377.82 284.06L387.84 274.03M408 253.88L412.1 249.77M379.61 284.11L380.28 283.44M380.66 283.07L382.46 281.26M384.48 279.25L387.78 275.95M408.05 255.67L413.95 249.77M380.2 285.37L380.28 285.29M385.1 280.48L387.72 277.86M408.11 257.46L415.8 249.77M385.1 282.33L387.65 279.77M408.17 259.25L416.88 250.54M386.21 283.07L387.59 281.68M408.23 261.04L418.18 251.09M408.29 262.84L420.03 251.09M408.35 264.63L416.88 256.09M418.59 254.39L420.51 252.46M408.41 266.42L416.88 257.94M420.44 254.39L420.51 254.31M423.15 251.68L423.74 251.09M408.47 268.21L409.1 267.57M409.1 267.57L416.88 259.79M423.15 253.53L425.13 251.55M408.52 270L410.95 267.57M410.95 267.57L416.88 261.64M424.14 254.39L425.13 253.4M408.58 271.79L412.8 267.57M408.64 273.59L414.65 267.57M412.8 267.57L416.88 263.49M414.65 267.57L416.88 265.34M408.87 275.21L416.5 267.57M416.5 267.57L416.88 267.19M409.6 276.33L416.88 269.04M410.34 277.44L416.88 270.89M411.07 278.56L416.88 272.74M412.23 279.25L416.88 274.59M413.89 279.44L416.88 276.44M414.03 281.14L416.88 278.29M414.03 282.99L416.89 280.14M415.81 283.07L418.12 280.76M416.22 284.51L419.97 280.76M418.52 284.06L420.51 282.07M420.37 284.06L420.51 283.92M423.15 281.28L423.67 280.76M423.15 283.13L425.13 281.15M424.07 284.06L425.13 283",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M408.7 275.38L408.87 275.21M408.76 277.17L409.6 276.33M408.82 278.96L410.34 277.44M408.88 280.75L411.07 278.56M408.96 282.52L411.4 280.08M410.26 283.07L411.4 281.93",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M381.23 285.37L380.28 284.43M382.46 284.76L380.77 283.07M386.78 285.37L385.1 283.7M388.63 285.37L386.32 283.07M390.48 285.37L387.56 282.46M391.23 284.27L387.62 280.67M391.23 282.42L387.68 278.88M391.23 280.57L387.74 277.09M391.23 278.72L387.8 275.3M391.23 276.87L387.86 273.51M391.23 275.02L387.92 271.71M391.23 273.17L387.98 269.92M405.28 285.37L405.27 285.37M391.23 271.32L388.03 268.13M407.13 285.37L405.27 283.52M408.98 285.37L405.27 281.67M391.23 269.47L389.33 267.57M391.23 267.62L391.18 267.57M389.33 267.57L388.09 266.34M391.18 267.57L388.15 264.55M410.83 285.37L405.27 279.82M391.23 265.77L388.21 262.76M411.4 284.09L410.37 283.07M408.9 281.6L405.27 277.97M391.23 263.92L388.27 260.96M414.53 285.37L414.03 284.88M408.84 279.69L405.27 276.11M391.23 262.07L388.33 259.17M416.22 285.21L414.07 283.07M416.22 283.36L415.92 283.07M408.78 277.77L405.27 274.26M408.72 275.86L405.27 272.41M391.23 260.22L388.39 257.38M391.23 258.37L388.45 255.59M408.65 273.95L405.27 270.56M408.59 272.03L405.27 268.71M391.23 256.52L388.5 253.8M391.23 254.67L388.56 252.01M408.53 270.12L405.98 267.57M408.46 268.21L407.83 267.57M405.98 267.57L405.27 266.86M407.83 267.57L405.27 265.01M391.23 252.82L388.64 250.23M391.23 250.97L390.49 250.23M408.4 266.3L405.27 263.16M408.34 264.38L405.27 261.31M408.28 262.47L405.27 259.46M408.21 260.56L405.27 257.61M408.15 258.64L405.27 255.76M408.09 256.73L405.27 253.91M408.03 254.82L405.27 252.06M407.96 252.9L405.29 250.23M407.9 250.99L407.14 250.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M374.67 262.06L374.67 245.19",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M421.83 262.06L421.83 245.19",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M384.74 249.77L416.06 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M380.28 285.37L416.22 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M387.56 282.47L388.64 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M386.94 283.07L387.38 282.89M387.38 282.89L387.56 282.47",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37 284.06L371.37 280.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 284.06L375.99 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37 284.06L373.35 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 284.06L379.61 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 284.06L375.99 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 275.73L375.99 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 275.73L373.35 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 274.45L373.35 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 274.45L375.99 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 274.12L375.66 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M373.68 274.12L373.68 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 274.12L375.99 274.45",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 274.45L373.68 274.12",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 274.45L375.99 274.45",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M373.68 274.12L375.66 274.12",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 277.35L377.3 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 277.35L372.03 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 275.73L372.93 275.51M372.93 275.51L372.45 275.51M372.45 275.51L372.03 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 275.73L375.12 275.51M375.12 275.51L374.22 275.51M374.22 275.51L373.35 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 275.73L376.88 275.51M376.88 275.51L376.41 275.51M376.41 275.51L375.99 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 277.35L372.45 277.57M372.45 277.57L372.93 277.57M372.93 277.57L373.35 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 277.35L376.41 277.57M376.41 277.57L376.88 277.57M376.88 277.57L377.3 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 277.35L374.22 277.57M374.22 277.57L375.12 277.57M375.12 277.57L375.99 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M372.69 275.48L376.65 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M372.69 277.59L376.65 277.59",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 280.23L372.03 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 280.23L377.3 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M377.83 280.76L377.83 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 280.23L377.83 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 280.76L371.5 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M382.79 279.25L384.77 279.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M382.46 279.58L385.1 279.58",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M384.77 279.25L385.1 279.58",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M382.46 279.58L382.79 279.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 277.84L372.93 277.62M372.93 277.62L372.45 277.62M372.45 277.62L372.03 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 277.84L375.12 277.62M375.12 277.62L374.22 277.62M374.22 277.62L373.35 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 277.84L376.88 277.62M376.88 277.62L376.41 277.62M376.41 277.62L375.99 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M386.42 285.9L386.42 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M385.1 285.9L385.1 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M381.14 285.9L381.14 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M382.46 285.9L382.46 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M381.8 288.54L385.76 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M385.1 288.3L385.52 288.51M385.52 288.51L386 288.51M386 288.51L386.42 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M382.46 288.3L383.33 288.51M383.33 288.51L384.23 288.51M384.23 288.51L385.1 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M381.14 288.3L381.57 288.51M381.57 288.51L382.04 288.51M382.04 288.51L382.46 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M380.44 285.37L387.03 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M380.44 285.37L387.03 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 285.9L375.99 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 285.9L373.35 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 288.3L374.22 288.51M374.22 288.51L375.12 288.51M375.12 288.51L375.99 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 288.3L376.41 288.51M376.41 288.51L376.88 288.51M376.88 288.51L377.3 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 288.3L372.45 288.51M372.45 288.51L372.93 288.51M372.93 288.51L373.35 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 285.9L372.03 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M372.69 288.54L376.65 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 285.9L377.3 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 285.9L377.83 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M377.83 285.37L377.83 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 285.37L371.5 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M386.95 285.37L386.95 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M380.62 285.9L386.95 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M380.62 285.37L380.62 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M382.79 279.25L382.79 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M384.77 279.25L384.77 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 277.84L375.99 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 277.84L373.35 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 280.76L375.66 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M373.68 280.76L373.68 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M383.78 291.42L383.78 276.65",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M385.1 279.58L385.1 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M382.46 279.58L382.46 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M374.67 273.08L374.67 289.96",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 285.37L379.61 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 251.09L375.99 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37 251.09L373.35 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 251.09L379.61 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 251.09L375.99 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M372.69 246.61L376.65 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 249.24L377.3 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 257.32L372.03 254.93",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 249.24L377.83 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 249.77L371.5 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M377.83 249.77L377.83 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 246.85L375.12 246.63M375.12 246.63L374.22 246.63M374.22 246.63L373.35 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 246.85L376.88 246.64M376.88 246.64L376.41 246.64M376.41 246.64L375.99 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 246.85L372.93 246.64M372.93 246.64L372.45 246.64M372.45 246.64L372.03 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 249.24L375.99 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 249.24L373.35 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 249.77L379.61 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M366.82 249.77L379.61 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 254.91L377.3 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 254.91L372.03 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M373.68 261.03L373.68 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 260.7L373.35 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 261.03L375.66 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 260.7L375.99 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 259.42L375.99 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 259.42L373.35 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 257.31L376.41 257.52M376.41 257.52L376.88 257.52M376.88 257.52L377.3 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M372.69 257.55L376.65 257.55",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 257.31L374.22 257.52M374.22 257.52L375.12 257.52M375.12 257.52L375.99 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 257.31L372.45 257.52M372.45 257.52L372.93 257.52M372.93 257.52L373.35 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 257.8L375.12 257.58M375.12 257.58L374.22 257.58M374.22 257.58L373.35 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 257.8L376.88 257.58M376.88 257.58L376.41 257.58M376.41 257.58L375.99 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 257.8L372.93 257.58M372.93 257.58L372.45 257.58M372.45 257.58L372.03 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 257.8L377.3 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 257.8L372.03 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M372.69 259.66L376.65 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M373.68 261.03L375.66 261.03",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 260.7L375.99 260.7",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 260.7L373.68 261.03",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 261.03L375.99 260.7",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 259.42L372.45 259.63M372.45 259.63L372.93 259.63M372.93 259.63L373.35 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 259.42L374.22 259.63M374.22 259.63L375.12 259.63M375.12 259.63L375.99 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 259.42L376.41 259.63M376.41 259.63L376.88 259.63M376.88 259.63L377.3 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 254.91L377.83 254.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 254.39L371.5 254.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M377.83 254.39L377.83 254.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 257.31L373.35 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 257.31L375.99 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M373.68 254.39L373.68 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 254.39L375.66 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37 254.39L371.37 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M425.13 284.06L425.13 280.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 284.06L420.51 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 284.06L425.13 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 284.06L420.51 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 277.84L420.51 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 277.84L423.15 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 275.73L423.15 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 275.73L420.51 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 274.45L420.51 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 274.12L420.84 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 274.12L422.82 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 274.45L423.15 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M423.81 277.59L419.85 277.59",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M423.81 275.48L419.85 275.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 277.35L421.38 277.57M421.38 277.57L422.28 277.57M422.28 277.57L423.15 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 277.35L419.61 277.57M419.61 277.57L420.09 277.57M420.09 277.57L420.51 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 277.35L423.57 277.57M423.57 277.57L424.04 277.57M424.04 277.57L424.47 277.35",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 275.73L420.09 275.51M420.09 275.51L419.61 275.51M419.61 275.51L419.19 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 275.73L422.28 275.51M422.28 275.51L421.38 275.51M421.38 275.51L420.51 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 275.73L424.04 275.51M424.04 275.51L423.57 275.51M423.57 275.51L423.15 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 277.35L424.47 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 277.35L419.19 275.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 274.12L420.84 274.12",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 274.45L420.51 274.45",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 274.45L422.82 274.12",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 274.12L420.51 274.45",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 280.23L418.66 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M417.5 280.76L425.13 280.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 280.23L419.19 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 280.23L424.47 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M418.66 280.76L418.66 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 280.76L424.99 280.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 277.84L420.09 277.62M420.09 277.62L419.61 277.62M419.61 277.62L419.19 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 277.84L422.28 277.62M422.28 277.62L421.38 277.62M421.38 277.62L420.51 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 277.84L424.04 277.62M424.04 277.62L423.57 277.62M423.57 277.62L423.15 277.84",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 285.9L418.66 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M409.47 285.37L416.06 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M409.47 285.37L416.06 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 285.9L419.19 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M423.81 288.54L419.85 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 288.3L419.61 288.51M419.61 288.51L420.09 288.51M420.09 288.51L420.51 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 288.3L421.38 288.51M421.38 288.51L422.28 288.51M422.28 288.51L423.15 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 285.9L420.51 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 285.9L424.47 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 285.9L423.15 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 288.3L423.57 288.51M423.57 288.51L424.04 288.51M424.04 288.51L424.47 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M418.66 285.37L418.66 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 285.37L424.99 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 280.76L420.84 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 280.76L422.82 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 280.76L420.51 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 280.76L423.15 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M421.83 273.08L421.83 289.96",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 285.37L416.88 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 251.09L420.51 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 251.09L425.13 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 251.09L420.51 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 249.24L418.66 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 249.77L416.88 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 249.24L420.51 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 249.24L423.15 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 246.85L422.28 246.63M422.28 246.63L421.38 246.63M421.38 246.63L420.51 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 246.85L420.09 246.64M420.09 246.64L419.61 246.64M419.61 246.64L419.19 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 246.85L424.04 246.64M424.04 246.64L423.57 246.64M423.57 246.64L423.15 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 249.24L424.47 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M423.81 246.61L419.85 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 249.24L419.19 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M418.66 249.77L418.66 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 249.77L424.99 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 254.91L424.47 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 254.91L419.19 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 261.03L422.82 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 261.03L420.84 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 260.7L420.51 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 260.7L423.15 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 259.42L423.15 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 259.42L420.51 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 257.8L419.19 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 257.8L424.47 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M424.47 257.8L424.04 257.58M424.04 257.58L423.57 257.58M423.57 257.58L423.15 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 257.8L420.09 257.58M420.09 257.58L419.61 257.58M419.61 257.58L419.19 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 257.8L422.28 257.58M422.28 257.58L421.38 257.58M421.38 257.58L420.51 257.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 257.31L423.57 257.52M423.57 257.52L424.04 257.52M424.04 257.52L424.47 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 257.31L421.38 257.52M421.38 257.52L422.28 257.52M422.28 257.52L423.15 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M423.81 257.55L419.85 257.55",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 257.31L419.61 257.52M419.61 257.52L420.09 257.52M420.09 257.52L420.51 257.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M423.81 259.66L419.85 259.66",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 261.03L420.51 260.7",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 260.7L422.82 261.03",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 260.7L420.51 260.7",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 261.03L420.84 261.03",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 259.42L423.57 259.63M423.57 259.63L424.04 259.63M424.04 259.63L424.47 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 259.42L421.38 259.63M421.38 259.63L422.28 259.63M422.28 259.63L423.15 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 259.42L419.61 259.63M419.61 259.63L420.09 259.63M420.09 259.63L420.51 259.42",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 254.91L418.66 254.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M417.5 254.39L425.13 254.39",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M418.66 254.39L418.66 254.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M424.99 254.39L424.99 254.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51 257.31L420.51 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 257.31L423.15 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 254.39L420.84 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 254.39L422.82 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M425.13 254.39L425.13 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 280.14L379.61 255.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M379.61 255.01L379.43 254.57M379.43 254.57L378.99 254.39",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37 280.76L378.99 280.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M378.99 280.76L379.43 280.58M379.43 280.58L379.61 280.14",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37 254.39L378.99 254.39",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 280.14L416.88 255.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M417.5 254.39L417.07 254.57M417.07 254.57L416.88 255.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 280.14L417.07 280.58M417.07 280.58L417.5 280.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M380.28 285.37L380.28 283.07",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M410.08 285.9L410.08 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M411.4 285.9L411.4 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M415.35 285.9L415.35 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M414.03 285.9L414.03 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M414.69 288.54L410.74 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M410.08 288.3L410.5 288.51M410.5 288.51L410.98 288.51M410.98 288.51L411.4 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M411.4 288.3L412.27 288.51M412.27 288.51L413.16 288.51M413.16 288.51L414.03 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M414.03 288.3L414.46 288.51M414.46 288.51L414.93 288.51M414.93 288.51L415.35 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M409.55 285.37L409.55 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M415.88 285.9L409.55 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M415.88 285.37L415.88 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M413.71 279.25L413.71 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M411.73 279.25L411.73 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M412.72 291.42L412.72 276.65",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M411.4 279.58L411.4 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M414.03 279.58L414.03 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M416.22 285.37L416.22 283.07",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M413.71 279.25L411.73 279.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M414.03 279.58L411.4 279.58",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M411.73 279.25L411.4 279.58",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M414.03 279.58L413.71 279.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M391.23 285.37L391.23 250.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M388.62 250.23L407.88 250.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M408.93 282.47L407.86 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M380.28 283.07L386.94 283.07",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M409.55 283.07L416.22 283.07",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M408.93 282.47L409.12 282.89M409.12 282.89L409.55 283.07",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 250.23L397.13 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M399.36 250.23L399.36 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M376.14 287.88L334.34 308.56",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M406.94 274.94L438.08 319.55",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M442.74 321.3L443.33 321M443.33 321L444.22 320.12M444.22 320.12L444.22 326.32M443.92 320.41L443.92 326.32M442.74 326.32L445.4 326.32",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M334.33 313.36L334.03 313.65M334.03 313.65L334.33 313.95M334.33 313.95L334.62 313.65M334.62 313.65L334.62 313.36M334.62 313.36L334.33 312.77M334.33 312.77L333.74 312.47M333.74 312.47L332.85 312.47M332.85 312.47L331.96 312.77M331.96 312.77L331.37 313.36M331.37 313.36L331.08 313.95M331.08 313.95L330.78 315.13M330.78 315.13L330.78 316.9M330.78 316.9L331.08 317.79M331.08 317.79L331.67 318.38M331.67 318.38L332.55 318.67M332.55 318.67L333.14 318.67M333.14 318.67L334.03 318.38M334.03 318.38L334.62 317.79M334.62 317.79L334.92 316.9M334.92 316.9L334.92 316.61M334.92 316.61L334.62 315.72M334.62 315.72L334.03 315.13M334.03 315.13L333.14 314.84M333.14 314.84L332.85 314.84M332.85 314.84L331.96 315.13M331.96 315.13L331.37 315.72M331.37 315.72L331.08 316.61M332.85 312.47L332.26 312.77M332.26 312.77L331.67 313.36M331.67 313.36L331.37 313.95M331.37 313.95L331.08 315.13M331.08 315.13L331.08 316.9M331.08 316.9L331.37 317.79M331.37 317.79L331.96 318.38M331.96 318.38L332.55 318.67M333.14 318.67L333.74 318.38M333.74 318.38L334.33 317.79M334.33 317.79L334.62 316.9M334.62 316.9L334.62 316.61M334.62 316.61L334.33 315.72M334.33 315.72L333.74 315.13M333.74 315.13L333.14 314.84",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M437.02 323.37L437.21 321.72M437.21 321.72L437.76 320.16M437.76 320.16L438.64 318.75M438.64 318.75L439.81 317.58M439.81 317.58L441.22 316.7M441.22 316.7L442.78 316.15M442.78 316.15L444.43 315.97M444.43 315.97L446.07 316.15M446.07 316.15L447.64 316.7M447.64 316.7L449.04 317.58M449.04 317.58L450.22 318.75M450.22 318.75L451.1 320.16M451.1 320.16L451.65 321.72M451.65 321.72L451.83 323.37M451.83 323.37L451.65 325.02M451.65 325.02L451.1 326.58M451.1 326.58L450.22 327.99M450.22 327.99L449.04 329.16M449.04 329.16L447.64 330.04M447.64 330.04L446.07 330.59M446.07 330.59L444.43 330.77M444.43 330.77L442.78 330.59M442.78 330.59L441.22 330.04M441.22 330.04L439.81 329.16M439.81 329.16L438.64 327.99M438.64 327.99L437.76 326.58M437.76 326.58L437.21 325.02M437.21 325.02L437.02 323.37",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M325.07 315.73L325.25 314.08M325.25 314.08L325.8 312.52M325.8 312.52L326.68 311.11M326.68 311.11L327.85 309.94M327.85 309.94L329.26 309.06M329.26 309.06L330.82 308.51M330.82 308.51L332.47 308.32M332.47 308.32L334.12 308.51M334.12 308.51L335.68 309.06M335.68 309.06L337.09 309.94M337.09 309.94L338.26 311.11M338.26 311.11L339.14 312.52M339.14 312.52L339.69 314.08M339.69 314.08L339.87 315.73M339.87 315.73L339.69 317.38M339.69 317.38L339.14 318.94M339.14 318.94L338.26 320.34M338.26 320.34L337.09 321.52M337.09 321.52L335.68 322.4M335.68 322.4L334.12 322.95M334.12 322.95L332.47 323.13M332.47 323.13L330.82 322.95M330.82 322.95L329.26 322.4M329.26 322.4L327.85 321.52M327.85 321.52L326.68 320.34M326.68 320.34L325.8 318.94M325.8 318.94L325.25 317.38M325.25 317.38L325.07 315.73",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M416.88 265.08L458.34 318.29",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M456.33 323.37L456.51 321.72M456.51 321.72L457.06 320.16M457.06 320.16L457.94 318.75M457.94 318.75L459.12 317.58M459.12 317.58L460.52 316.7M460.52 316.7L462.08 316.15M462.08 316.15L463.73 315.97M463.73 315.97L465.38 316.15M465.38 316.15L466.94 316.7M466.94 316.7L468.35 317.58M468.35 317.58L469.52 318.75M469.52 318.75L470.4 320.16M470.4 320.16L470.95 321.72M470.95 321.72L471.13 323.37M471.13 323.37L470.95 325.02M470.95 325.02L470.4 326.58M470.4 326.58L469.52 327.99M469.52 327.99L468.35 329.16M468.35 329.16L466.94 330.04M466.94 330.04L465.38 330.59M465.38 330.59L463.73 330.77M463.73 330.77L462.08 330.59M462.08 330.59L460.52 330.04M460.52 330.04L459.12 329.16M459.12 329.16L457.94 327.99M457.94 327.99L457.06 326.58M457.06 326.58L456.51 325.02M456.51 325.02L456.33 323.37",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M381.14 287.1L355.54 308.61",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M351.84 312.47L351.84 314.25M351.84 313.65L352.13 313.06M352.13 313.06L352.72 312.47M352.72 312.47L353.31 312.47M353.31 312.47L354.79 313.36M354.79 313.36L355.38 313.36M355.38 313.36L355.67 313.06M355.67 313.06L355.97 312.47M352.13 313.06L352.72 312.77M352.72 312.77L353.31 312.77M353.31 312.77L354.79 313.36M355.97 312.47L355.97 313.36M355.97 313.36L355.67 314.25M355.67 314.25L354.49 315.72M354.49 315.72L354.2 316.31M354.2 316.31L353.9 317.2M353.9 317.2L353.9 318.67M355.67 314.25L354.2 315.72M354.2 315.72L353.9 316.31M353.9 316.31L353.61 317.2M353.61 317.2L353.61 318.67",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M346.12 315.73L346.31 314.08M346.31 314.08L346.85 312.52M346.85 312.52L347.74 311.11M347.74 311.11L348.91 309.94M348.91 309.94L350.31 309.06M350.31 309.06L351.88 308.51M351.88 308.51L353.52 308.32M353.52 308.32L355.17 308.51M355.17 308.51L356.74 309.06M356.74 309.06L358.14 309.94M358.14 309.94L359.31 311.11M359.31 311.11L360.19 312.52M360.19 312.52L360.74 314.08M360.74 314.08L360.93 315.73M360.93 315.73L360.74 317.38M360.74 317.38L360.19 318.94M360.19 318.94L359.31 320.34M359.31 320.34L358.14 321.52M358.14 321.52L356.74 322.4M356.74 322.4L355.17 322.95M355.17 322.95L353.52 323.13M353.52 323.13L351.88 322.95M351.88 322.95L350.31 322.4M350.31 322.4L348.91 321.52M348.91 321.52L347.74 320.34M347.74 320.34L346.85 318.94M346.85 318.94L346.31 317.38M346.31 317.38L346.12 315.73",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M462.64 321.29L462.94 321.59M462.94 321.59L462.64 321.88M462.64 321.88L462.35 321.59M462.35 321.59L462.35 321.29M462.35 321.29L462.64 320.7M462.64 320.7L462.94 320.4M462.94 320.4L463.82 320.11M463.82 320.11L465 320.11M465 320.11L465.89 320.4M465.89 320.4L466.18 320.7M466.18 320.7L466.48 321.29M466.48 321.29L466.48 321.88M466.48 321.88L466.18 322.47M466.18 322.47L465.3 323.06M465.3 323.06L463.82 323.65M463.82 323.65L463.23 323.95M463.23 323.95L462.64 324.54M462.64 324.54L462.35 325.42M462.35 325.42L462.35 326.31M465 320.11L465.59 320.4M465.59 320.4L465.89 320.7M465.89 320.7L466.18 321.29M466.18 321.29L466.18 321.88M466.18 321.88L465.89 322.47M465.89 322.47L465 323.06M465 323.06L463.82 323.65M462.35 325.72L462.64 325.42M462.64 325.42L463.23 325.42M463.23 325.42L464.71 326.01M464.71 326.01L465.59 326.01M465.59 326.01L466.18 325.72M466.18 325.72L466.48 325.42M463.23 325.42L464.71 326.31M464.71 326.31L465.89 326.31M465.89 326.31L466.18 326.01M466.18 326.01L466.48 325.42M466.48 325.42L466.48 324.83",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 249.24L372.03 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M405.27 285.37L405.27 250.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M729.08 284.44L729.08 244.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M486.5 290.23L488.54 291.62M488.54 291.62L490.75 292.74M490.75 292.74L493.09 293.54M493.09 293.54L495.52 294.03M495.52 294.03L497.99 294.2",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M469.64 258.16L486.01 235.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M501.07 227.94L498.57 228.1M498.57 228.1L496.11 228.61M496.11 228.61L493.75 229.43M493.75 229.43L491.52 230.57M491.52 230.57L489.46 232M489.46 232L487.61 233.69M487.61 233.69L486.01 235.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M486.5 290.23L469.64 276.99",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M497.99 294.2L729.08 284.44",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M501.07 227.94L729.08 244.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M67.42 284.44L67.42 244.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M298.51 294.2L300.98 294.03M300.98 294.03L303.41 293.54M303.41 293.54L305.75 292.74M305.75 292.74L307.96 291.62M307.96 291.62L310 290.23",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M326.86 258.16L310.49 235.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M310.49 235.61L308.88 233.69M308.88 233.69L307.04 232M307.04 232L304.98 230.57M304.98 230.57L302.75 229.43M302.75 229.43L300.38 228.61M300.38 228.61L297.93 228.1M297.93 228.1L295.43 227.94",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M310 290.23L326.86 276.99",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M298.51 294.2L67.42 284.44",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M295.43 227.94L67.42 244.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M729.08 157.62L729.08 117.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M486.5 163.41L488.54 164.81M488.54 164.81L490.75 165.92M490.75 165.92L493.09 166.73M493.09 166.73L495.52 167.22M495.52 167.22L497.99 167.38",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M469.11 132.07L486.01 108.79",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M501.07 101.12L498.57 101.29M498.57 101.29L496.11 101.79M496.11 101.79L493.75 102.62M493.75 102.62L491.52 103.75M491.52 103.75L489.46 105.18M489.46 105.18L487.61 106.87M487.61 106.87L486.01 108.79",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M486.5 163.41L469.07 149.72",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M497.99 167.38L729.08 157.62",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M501.07 101.12L729.08 117.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M67.61 123.91L67.61 163.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M310.19 118.12L308.14 116.72M308.14 116.72L305.93 115.61M305.93 115.61L303.59 114.8M303.59 114.8L301.16 114.31M301.16 114.31L298.69 114.15",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M327.58 149.46L310.67 172.74",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M295.62 180.41L298.11 180.24M298.11 180.24L300.57 179.74M300.57 179.74L302.93 178.91M302.93 178.91L305.16 177.78M305.16 177.78L307.22 176.35M307.22 176.35L309.07 174.66M309.07 174.66L310.67 172.74",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M310.19 118.12L327.61 131.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M298.69 114.15L67.61 123.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M295.62 180.41L67.61 163.8",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5 152.43L350.5 147.65M350.5 145.68L350.5 141.74M350.5 139.77L350.5 135.83M350.5 133.87L350.5 129.08",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5 129.08L347.99 129.08",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5 152.43L347.99 152.43",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M328.96 251.09L328.96 266.56",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M328.96 268.59L328.96 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M347.99 251.09L347.99 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M327.03 249.77L327.03 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M327.03 284.06L327.03 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M326.86 258.16L328.96 258.16",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M326.86 276.99L328.96 276.99",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M347.99 266.56L328.96 266.56",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M347.99 268.59L328.96 268.59",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5 279.25L350.5 255.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5 255.9L347.99 255.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5 279.25L347.99 279.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M343.74 293.56L343.74 275.28M343.74 271.34L343.74 267.4M343.74 263.47L343.74 245.19",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M341.76 246.61L345.72 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 249.24L346.37 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M340.57 249.24L346.9 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M340.57 249.77L340.57 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M346.9 249.77L346.9 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 246.85L344.19 246.63M344.19 246.63L343.29 246.63M343.29 246.63L342.42 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 246.85L345.95 246.64M345.95 246.64L345.48 246.64M345.48 246.64L345.06 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 246.85L342 246.64M342 246.64L341.52 246.64M341.52 246.64L341.1 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 249.24L345.06 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 249.24L342.42 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M341.1 249.24L341.1 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M341.1 288.31L341.1 285.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 285.9L346.37 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M341.1 285.9L341.1 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M342.75 292.01L342.75 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 291.69L342.42 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M344.73 292.01L344.73 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 291.69L345.06 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 290.41L345.06 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 290.41L342.42 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 288.3L345.48 288.51M345.48 288.51L345.95 288.51M345.95 288.51L346.37 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M341.76 288.54L345.72 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 288.3L343.29 288.51M343.29 288.51L344.19 288.51M344.19 288.51L345.06 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M341.1 288.3L341.52 288.51M341.52 288.51L342 288.51M342 288.51L342.42 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 288.78L344.19 288.57M344.19 288.57L343.29 288.57M343.29 288.57L342.42 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 288.78L345.95 288.57M345.95 288.57L345.48 288.57M345.48 288.57L345.06 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 288.78L342 288.57M342 288.57L341.52 288.57M341.52 288.57L341.1 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 288.78L346.37 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M341.1 288.78L341.1 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M341.76 290.65L345.72 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M342.75 292.01L344.73 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 291.69L345.06 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 291.69L342.75 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M344.73 292.01L345.06 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M341.1 290.41L341.52 290.62M341.52 290.62L342 290.62M342 290.62L342.42 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 290.41L343.29 290.62M343.29 290.62L344.19 290.62M344.19 290.62L345.06 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 290.41L345.48 290.62M345.48 290.62L345.95 290.62M345.95 290.62L346.37 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M340.57 285.9L346.9 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M340.57 285.37L340.57 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M346.9 285.37L346.9 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 288.3L342.42 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 288.3L345.06 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M345.06 285.37L345.06 283.32M345.06 281.35L345.06 277.42M345.06 275.45L345.06 271.51M345.06 269.54L345.06 265.6M345.06 263.64L345.06 259.7M345.06 257.73L345.06 253.79M345.06 251.82L345.06 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M342.42 285.37L342.42 283.32M342.42 281.35L342.42 277.42M342.42 275.45L342.42 271.51M342.42 269.54L342.42 265.6M342.42 263.64L342.42 259.7M342.42 257.73L342.42 253.79M342.42 251.82L342.42 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M333.21 293.56L333.21 275.28M333.21 271.34L333.21 267.4M333.21 263.47L333.21 245.19",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M331.23 246.61L335.19 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 249.24L335.85 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M330.05 249.24L336.38 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M330.05 249.77L330.05 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M336.38 249.77L336.38 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 246.85L333.66 246.63M333.66 246.63L332.76 246.63M332.76 246.63L331.89 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 246.85L335.43 246.64M335.43 246.64L334.95 246.64M334.95 246.64L334.53 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 246.85L331.47 246.64M331.47 246.64L331 246.64M331 246.64L330.57 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 249.24L334.53 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 249.24L331.89 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M330.57 249.24L330.57 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M330.57 288.31L330.57 285.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 285.9L335.85 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M330.57 285.9L330.57 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M332.22 292.01L332.22 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 291.69L331.89 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M334.2 292.01L334.2 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 291.69L334.53 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 290.41L334.53 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 290.41L331.89 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 288.3L334.95 288.51M334.95 288.51L335.43 288.51M335.43 288.51L335.85 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M331.23 288.54L335.19 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 288.3L332.76 288.51M332.76 288.51L333.66 288.51M333.66 288.51L334.53 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M330.57 288.3L331 288.51M331 288.51L331.47 288.51M331.47 288.51L331.89 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 288.78L333.66 288.57M333.66 288.57L332.76 288.57M332.76 288.57L331.89 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 288.78L335.43 288.57M335.43 288.57L334.95 288.57M334.95 288.57L334.53 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 288.78L331.47 288.57M331.47 288.57L331 288.57M331 288.57L330.57 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 288.78L335.85 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M330.57 288.78L330.57 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M331.23 290.65L335.19 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M332.22 292.01L334.2 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 291.69L334.53 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 291.69L332.22 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M334.2 292.01L334.53 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M330.57 290.41L331 290.62M331 290.62L331.47 290.62M331.47 290.62L331.89 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 290.41L332.76 290.62M332.76 290.62L333.66 290.62M333.66 290.62L334.53 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 290.41L334.95 290.62M334.95 290.62L335.43 290.62M335.43 290.62L335.85 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M330.05 285.9L336.38 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M330.05 285.37L330.05 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M336.38 285.37L336.38 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 288.3L331.89 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 288.3L334.53 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53 285.37L334.53 283.32M334.53 281.35L334.53 277.42M334.53 275.45L334.53 271.51M334.53 269.54L334.53 265.6M334.53 263.64L334.53 259.7M334.53 257.73L334.53 253.79M334.53 251.82L334.53 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M331.89 285.37L331.89 283.32M331.89 281.35L331.89 277.42M331.89 275.45L331.89 271.51M331.89 269.54L331.89 265.6M331.89 263.64L331.89 259.7M331.89 257.73L331.89 253.79M331.89 251.82L331.89 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M467.54 251.09L467.54 266.56",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M467.54 268.59L467.54 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M448.51 251.09L448.51 284.06",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M469.47 249.77L469.47 251.09",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M469.47 284.06L469.47 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M469.64 258.16L467.54 258.16",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M469.64 276.99L467.54 276.99",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M448.51 266.56L467.54 266.56",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M448.51 268.59L467.54 268.59",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M446 279.25L446 255.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M446 255.9L448.51 255.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M446 279.25L448.51 279.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M452.76 293.56L452.76 275.28M452.76 271.34L452.76 267.4M452.76 263.47L452.76 245.19",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M454.74 246.61L450.78 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M450.12 249.24L450.12 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M455.92 249.24L449.59 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M455.92 249.77L455.92 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M449.59 249.77L449.59 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 246.85L453.21 246.63M453.21 246.63L452.31 246.63M452.31 246.63L451.44 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 246.85L451.02 246.64M451.02 246.64L450.54 246.64M450.54 246.64L450.12 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M455.4 246.85L454.97 246.64M454.97 246.64L454.5 246.64M454.5 246.64L454.08 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 249.24L451.44 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 249.24L454.08 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M455.4 249.24L455.4 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M455.4 288.31L455.4 285.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M450.12 285.9L450.12 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M455.4 285.9L455.4 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M453.75 292.01L453.75 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 291.69L454.08 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M451.77 292.01L451.77 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 291.69L451.44 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 290.41L451.44 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 290.41L454.08 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M450.12 288.3L450.54 288.51M450.54 288.51L451.02 288.51M451.02 288.51L451.44 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M454.74 288.54L450.78 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 288.3L452.31 288.51M452.31 288.51L453.21 288.51M453.21 288.51L454.08 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 288.3L454.5 288.51M454.5 288.51L454.97 288.51M454.97 288.51L455.4 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 288.78L453.21 288.57M453.21 288.57L452.31 288.57M452.31 288.57L451.44 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 288.78L451.02 288.57M451.02 288.57L450.54 288.57M450.54 288.57L450.12 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M455.4 288.78L454.97 288.57M454.97 288.57L454.5 288.57M454.5 288.57L454.08 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M450.12 288.78L450.12 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M455.4 288.78L455.4 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M454.74 290.65L450.78 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M453.75 292.01L451.77 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 291.69L451.44 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 291.69L453.75 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M451.77 292.01L451.44 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 290.41L454.5 290.62M454.5 290.62L454.97 290.62M454.97 290.62L455.4 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 290.41L452.31 290.62M452.31 290.62L453.21 290.62M453.21 290.62L454.08 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M450.12 290.41L450.54 290.62M450.54 290.62L451.02 290.62M451.02 290.62L451.44 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M455.92 285.9L449.59 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M455.92 285.37L455.92 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M449.59 285.37L449.59 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 288.3L454.08 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 288.3L451.44 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 285.37L451.44 283.32M451.44 281.35L451.44 277.42M451.44 275.45L451.44 271.51M451.44 269.54L451.44 265.6M451.44 263.64L451.44 259.7M451.44 257.73L451.44 253.79M451.44 251.82L451.44 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M454.08 285.37L454.08 283.32M454.08 281.35L454.08 277.42M454.08 275.45L454.08 271.51M454.08 269.54L454.08 265.6M454.08 263.64L454.08 259.7M454.08 257.73L454.08 253.79M454.08 251.82L454.08 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M463.29 293.56L463.29 275.28M463.29 271.34L463.29 267.4M463.29 263.47L463.29 245.19",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M465.26 246.61L461.31 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M460.65 249.24L460.65 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M466.45 249.24L460.12 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M466.45 249.77L466.45 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M460.12 249.77L460.12 249.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 246.85L463.73 246.63M463.73 246.63L462.84 246.63M462.84 246.63L461.97 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 246.85L461.54 246.64M461.54 246.64L461.07 246.64M461.07 246.64L460.65 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92 246.85L465.5 246.64M465.5 246.64L465.03 246.64M465.03 246.64L464.6 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 249.24L461.97 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 249.24L464.6 246.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92 249.24L465.92 246.85",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92 288.31L465.92 285.91",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M460.65 285.9L460.65 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92 285.9L465.92 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M464.27 292.01L464.27 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 291.69L464.6 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M462.3 292.01L462.3 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 291.69L461.97 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 290.41L461.97 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 290.41L464.6 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M460.65 288.3L461.07 288.51M461.07 288.51L461.54 288.51M461.54 288.51L461.97 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M465.26 288.54L461.31 288.54",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 288.3L462.84 288.51M462.84 288.51L463.73 288.51M463.73 288.51L464.6 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 288.3L465.03 288.51M465.03 288.51L465.5 288.51M465.5 288.51L465.92 288.3",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 288.78L463.73 288.57M463.73 288.57L462.84 288.57M462.84 288.57L461.97 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 288.78L461.54 288.57M461.54 288.57L461.07 288.57M461.07 288.57L460.65 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92 288.78L465.5 288.57M465.5 288.57L465.03 288.57M465.03 288.57L464.6 288.78",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M460.65 288.78L460.65 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92 288.78L465.92 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M465.26 290.65L461.31 290.65",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M464.27 292.01L462.3 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 291.69L461.97 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 291.69L464.27 292.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M462.3 292.01L461.97 291.69",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 290.41L465.03 290.62M465.03 290.62L465.5 290.62M465.5 290.62L465.92 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 290.41L462.84 290.62M462.84 290.62L463.73 290.62M463.73 290.62L464.6 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M460.65 290.41L461.07 290.62M461.07 290.62L461.54 290.62M461.54 290.62L461.97 290.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M466.45 285.9L460.12 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M466.45 285.37L466.45 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M460.12 285.37L460.12 285.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 288.3L464.6 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 288.3L461.97 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M461.97 285.37L461.97 283.32M461.97 281.35L461.97 277.42M461.97 275.45L461.97 271.51M461.97 269.54L461.97 265.6M461.97 263.64L461.97 259.7M461.97 257.73L461.97 253.79M461.97 251.82L461.97 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6 285.37L464.6 283.32M464.6 281.35L464.6 277.42M464.6 275.45L464.6 271.51M464.6 269.54L464.6 265.6M464.6 263.64L464.6 259.7M464.6 257.73L464.6 253.79M464.6 251.82L464.6 249.77",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M347.99 153.94L347.99 150.6M347.99 148.63L347.99 144.69M347.99 142.72L347.99 138.79M347.99 136.82L347.99 132.88M347.99 130.91L347.99 127.57",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M333.21 125.55L333.21 156.11",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M328.96 153.94L328.96 150.6M328.96 148.63L328.96 144.69M328.96 142.72L328.96 138.79M328.96 136.82L328.96 132.88M328.96 130.91L328.96 127.57",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M347.99 153.94L345.36 153.94M343.4 153.94L339.46 153.94M337.49 153.94L333.55 153.94M331.58 153.94L328.96 153.94",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M347.99 127.57L345.36 127.57M343.4 127.57L339.46 127.57M337.49 127.57L333.55 127.57M331.58 127.57L328.96 127.57",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M330.93 131.26L331.12 130.33M331.12 130.33L331.68 129.56M331.68 129.56L332.51 129.09M332.51 129.09L333.45 128.99M333.45 128.99L334.35 129.28M334.35 129.28L335.06 129.92M335.06 129.92L335.45 130.79M335.45 130.79L335.45 131.74M335.45 131.74L335.06 132.6M335.06 132.6L334.35 133.24M334.35 133.24L333.45 133.53M333.45 133.53L332.51 133.43M332.51 133.43L331.68 132.96M331.68 132.96L331.12 132.19M331.12 132.19L330.93 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 131.26L334.53 128.98M334.53 128.98L331.89 128.98M331.89 128.98L330.57 131.26M330.57 131.26L331.89 133.55M331.89 133.55L334.53 133.55M334.53 133.55L335.85 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M332.02 131.26L332.21 130.62M332.21 130.62L332.72 130.18M332.72 130.18L333.38 130.09M333.38 130.09L333.99 130.36M333.99 130.36L334.35 130.93M334.35 130.93L334.35 131.6M334.35 131.6L333.99 132.16M333.99 132.16L333.38 132.44M333.38 132.44L332.72 132.34M332.72 132.34L332.21 131.9M332.21 131.9L332.02 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M341.45 131.26L341.65 130.33M341.65 130.33L342.21 129.56M342.21 129.56L343.03 129.09M343.03 129.09L343.98 128.99M343.98 128.99L344.88 129.28M344.88 129.28L345.58 129.92M345.58 129.92L345.97 130.79M345.97 130.79L345.97 131.74M345.97 131.74L345.58 132.6M345.58 132.6L344.88 133.24M344.88 133.24L343.98 133.53M343.98 133.53L343.03 133.43M343.03 133.43L342.21 132.96M342.21 132.96L341.65 132.19M341.65 132.19L341.45 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 131.26L345.06 128.98M345.06 128.98L342.42 128.98M342.42 128.98L341.1 131.26M341.1 131.26L342.42 133.55M342.42 133.55L345.06 133.55M345.06 133.55L346.37 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M342.55 131.26L342.74 130.62M342.74 130.62L343.24 130.18M343.24 130.18L343.91 130.09M343.91 130.09L344.51 130.36M344.51 130.36L344.88 130.93M344.88 130.93L344.88 131.6M344.88 131.6L344.51 132.16M344.51 132.16L343.91 132.44M343.91 132.44L343.24 132.34M343.24 132.34L342.74 131.9M342.74 131.9L342.55 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M330.93 150.25L331.12 149.32M331.12 149.32L331.68 148.55M331.68 148.55L332.51 148.08M332.51 148.08L333.45 147.98M333.45 147.98L334.35 148.27M334.35 148.27L335.06 148.91M335.06 148.91L335.45 149.78M335.45 149.78L335.45 150.73M335.45 150.73L335.06 151.59M335.06 151.59L334.35 152.23M334.35 152.23L333.45 152.52M333.45 152.52L332.51 152.42M332.51 152.42L331.68 151.95M331.68 151.95L331.12 151.18M331.12 151.18L330.93 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 150.25L334.53 152.53M334.53 152.53L331.89 152.53M331.89 152.53L330.57 150.25M330.57 150.25L331.89 147.97M331.89 147.97L334.53 147.97M334.53 147.97L335.85 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M332.02 150.25L332.21 149.61M332.21 149.61L332.72 149.17M332.72 149.17L333.38 149.08M333.38 149.08L333.99 149.35M333.99 149.35L334.35 149.92M334.35 149.92L334.35 150.59M334.35 150.59L333.99 151.15M333.99 151.15L333.38 151.43M333.38 151.43L332.72 151.33M332.72 151.33L332.21 150.89M332.21 150.89L332.02 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M341.45 150.25L341.65 149.32M341.65 149.32L342.21 148.55M342.21 148.55L343.03 148.08M343.03 148.08L343.98 147.98M343.98 147.98L344.88 148.27M344.88 148.27L345.58 148.91M345.58 148.91L345.97 149.78M345.97 149.78L345.97 150.73M345.97 150.73L345.58 151.59M345.58 151.59L344.88 152.23M344.88 152.23L343.98 152.52M343.98 152.52L343.03 152.42M343.03 152.42L342.21 151.95M342.21 151.95L341.65 151.18M341.65 151.18L341.45 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 150.25L345.06 152.53M345.06 152.53L342.42 152.53M342.42 152.53L341.1 150.25M341.1 150.25L342.42 147.97M342.42 147.97L345.06 147.97M345.06 147.97L346.37 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M342.55 150.25L342.74 149.61M342.74 149.61L343.24 149.17M343.24 149.17L343.91 149.08M343.91 149.08L344.51 149.35M344.51 149.35L344.88 149.92M344.88 149.92L344.88 150.59M344.88 150.59L344.51 151.15M344.51 151.15L343.91 151.43M343.91 151.43L343.24 151.33M343.24 151.33L342.74 150.89M342.74 150.89L342.55 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M343.74 125.55L343.74 156.11",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M349.44 131.26L327.5 131.26",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M349.44 150.25L327.5 150.25",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M384.58 190.95L381.68 189.28M379.98 188.29L376.57 186.33M374.87 185.34L371.46 183.37M369.75 182.39L366.34 180.42M364.64 179.44L361.74 177.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M352.61 189.55L379.07 204.83",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M375.07 207.43L372.17 205.76M370.47 204.77L367.06 202.8M365.35 201.82L361.94 199.85M360.24 198.87L356.83 196.9M355.12 195.91L352.23 194.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M384.58 190.95L383.27 193.22M382.28 194.93L380.32 198.34M379.33 200.04L377.36 203.45M376.38 205.16L375.07 207.43",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M361.74 177.76L360.43 180.04M359.44 181.74L357.48 185.15M356.49 186.86L354.52 190.26M353.54 191.97L352.23 194.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M355.27 192.41L355.46 191.48M355.46 191.48L356.02 190.71M356.02 190.71L356.84 190.23M356.84 190.23L357.79 190.13M357.79 190.13L358.69 190.43M358.69 190.43L359.4 191.06M359.4 191.06L359.78 191.93M359.78 191.93L359.78 192.88M359.78 192.88L359.4 193.75M359.4 193.75L358.69 194.38M358.69 194.38L357.79 194.68M357.79 194.68L356.84 194.58M356.84 194.58L356.02 194.1M356.02 194.1L355.46 193.34M355.46 193.34L355.27 192.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M358.87 190.12L356.23 190.12M356.23 190.12L354.91 192.41M354.91 192.41L356.23 194.69M356.23 194.69L358.87 194.69M358.87 194.69L360.19 192.41M360.19 192.41L358.87 190.12",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M356.36 192.41L356.55 191.76M356.55 191.76L357.06 191.33M357.06 191.33L357.72 191.23M357.72 191.23L358.33 191.51M358.33 191.51L358.69 192.07M358.69 192.07L358.69 192.74M358.69 192.74L358.33 193.3M358.33 193.3L357.72 193.58M357.72 193.58L357.06 193.49M357.06 193.49L356.55 193.05M356.55 193.05L356.36 192.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M360.53 183.29L360.73 182.36M360.73 182.36L361.28 181.59M361.28 181.59L362.11 181.12M362.11 181.12L363.05 181.02M363.05 181.02L363.95 181.31M363.95 181.31L364.66 181.95M364.66 181.95L365.05 182.82M365.05 182.82L365.05 183.77M365.05 183.77L364.66 184.63M364.66 184.63L363.95 185.27M363.95 185.27L363.05 185.56M363.05 185.56L362.11 185.46M362.11 185.46L361.28 184.99M361.28 184.99L360.73 184.22M360.73 184.22L360.53 183.29",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M364.13 181.01L361.49 181.01M361.49 181.01L360.18 183.29M360.18 183.29L361.49 185.57M361.49 185.57L364.13 185.57M364.13 185.57L365.45 183.29M365.45 183.29L364.13 181.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M361.63 183.29L361.81 182.65M361.81 182.65L362.32 182.21M362.32 182.21L362.98 182.12M362.98 182.12L363.59 182.39M363.59 182.39L363.95 182.96M363.95 182.96L363.95 183.62M363.95 183.62L363.59 184.19M363.59 184.19L362.98 184.46M362.98 184.46L362.32 184.37M362.32 184.37L361.81 183.93M361.81 183.93L361.63 183.29",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M371.71 201.9L371.91 200.97M371.91 200.97L372.47 200.2M372.47 200.2L373.29 199.73M373.29 199.73L374.23 199.63M374.23 199.63L375.14 199.92M375.14 199.92L375.84 200.56M375.84 200.56L376.23 201.43M376.23 201.43L376.23 202.38M376.23 202.38L375.84 203.24M375.84 203.24L375.14 203.88M375.14 203.88L374.23 204.17M374.23 204.17L373.29 204.07M373.29 204.07L372.47 203.6M372.47 203.6L371.91 202.83M371.91 202.83L371.71 201.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M375.31 199.62L376.63 201.9M376.63 201.9L375.31 204.19M375.31 204.19L372.68 204.19M372.68 204.19L371.36 201.9M371.36 201.9L372.68 199.62M372.68 199.62L375.31 199.62",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M372.81 201.9L373 201.26M373 201.26L373.5 200.82M373.5 200.82L374.16 200.73M374.16 200.73L374.77 201M374.77 201L375.13 201.57M375.13 201.57L375.13 202.24M375.13 202.24L374.77 202.8M374.77 202.8L374.16 203.08M374.16 203.08L373.5 202.98M373.5 202.98L373 202.54M373 202.54L372.81 201.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M376.97 192.79L377.17 191.86M377.17 191.86L377.73 191.09M377.73 191.09L378.55 190.61M378.55 190.61L379.5 190.51M379.5 190.51L380.4 190.81M380.4 190.81L381.11 191.44M381.11 191.44L381.49 192.31M381.49 192.31L381.49 193.26M381.49 193.26L381.11 194.13M381.11 194.13L380.4 194.76M380.4 194.76L379.5 195.06M379.5 195.06L378.55 194.96M378.55 194.96L377.73 194.48M377.73 194.48L377.17 193.71M377.17 193.71L376.97 192.79",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M380.58 190.5L381.9 192.79M381.9 192.79L380.58 195.07M380.58 195.07L377.94 195.07M377.94 195.07L376.62 192.79M376.62 192.79L377.94 190.5M377.94 190.5L380.58 190.5",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M378.07 192.79L378.26 192.14M378.26 192.14L378.77 191.71M378.77 191.71L379.43 191.61M379.43 191.61L380.03 191.89M380.03 191.89L380.4 192.45M380.4 192.45L380.4 193.12M380.4 193.12L380.03 193.68M380.03 193.68L379.43 193.96M379.43 193.96L378.77 193.86M378.77 193.86L378.26 193.43M378.26 193.43L378.07 192.79",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M357.87 180.44L384.34 195.72",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M365.67 178.35L354.7 197.35",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M382.11 187.84L371.14 206.84",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M434.93 177.76L432.03 179.44M430.33 180.42L426.92 182.39M425.21 183.37L421.8 185.34M420.1 186.33L416.69 188.29M414.98 189.28L412.09 190.95",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M417.73 204.75L444.19 189.47",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M444.44 194.24L441.54 195.91M439.84 196.9L436.43 198.87M434.72 199.85L431.31 201.82M429.61 202.8L426.2 204.77M424.5 205.76L421.6 207.43",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M434.93 177.76L436.24 180.04M437.22 181.74L439.19 185.15M440.17 186.86L442.14 190.26M443.13 191.97L444.44 194.24",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M412.09 190.95L413.4 193.22M414.38 194.93L416.35 198.34M417.34 200.04L419.3 203.45M420.29 205.16L421.6 207.43",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M420.39 201.9L420.59 200.97M420.59 200.97L421.14 200.2M421.14 200.2L421.97 199.73M421.97 199.73L422.91 199.63M422.91 199.63L423.81 199.92M423.81 199.92L424.52 200.56M424.52 200.56L424.91 201.43M424.91 201.43L424.91 202.38M424.91 202.38L424.52 203.24M424.52 203.24L423.81 203.88M423.81 203.88L422.91 204.17M422.91 204.17L421.97 204.07M421.97 204.07L421.14 203.6M421.14 203.6L420.59 202.83M420.59 202.83L420.39 201.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M421.35 199.62L420.03 201.9M420.03 201.9L421.35 204.19M421.35 204.19L423.99 204.19M423.99 204.19L425.31 201.9M425.31 201.9L423.99 199.62M423.99 199.62L421.35 199.62",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M421.49 201.9L421.67 201.26M421.67 201.26L422.18 200.82M422.18 200.82L422.84 200.73M422.84 200.73L423.45 201M423.45 201L423.81 201.57M423.81 201.57L423.81 202.24M423.81 202.24L423.45 202.8M423.45 202.8L422.84 203.08M422.84 203.08L422.18 202.98M422.18 202.98L421.67 202.54M421.67 202.54L421.49 201.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M415.12 192.79L415.32 191.86M415.32 191.86L415.88 191.09M415.88 191.09L416.7 190.61M416.7 190.61L417.65 190.51M417.65 190.51L418.55 190.81M418.55 190.81L419.26 191.44M419.26 191.44L419.64 192.31M419.64 192.31L419.64 193.26M419.64 193.26L419.26 194.13M419.26 194.13L418.55 194.76M418.55 194.76L417.65 195.06M417.65 195.06L416.7 194.96M416.7 194.96L415.88 194.48M415.88 194.48L415.32 193.71M415.32 193.71L415.12 192.79",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M416.09 190.5L414.77 192.79M414.77 192.79L416.09 195.07M416.09 195.07L418.73 195.07M418.73 195.07L420.05 192.79M420.05 192.79L418.73 190.5M418.73 190.5L416.09 190.5",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M416.22 192.79L416.41 192.14M416.41 192.14L416.92 191.71M416.92 191.71L417.58 191.61M417.58 191.61L418.19 191.89M418.19 191.89L418.55 192.45M418.55 192.45L418.55 193.12M418.55 193.12L418.19 193.68M418.19 193.68L417.58 193.96M417.58 193.96L416.92 193.86M416.92 193.86L416.41 193.43M416.41 193.43L416.22 192.79",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M436.83 192.41L437.03 191.48M437.03 191.48L437.59 190.71M437.59 190.71L438.41 190.23M438.41 190.23L439.36 190.13M439.36 190.13L440.26 190.43M440.26 190.43L440.96 191.06M440.96 191.06L441.35 191.93M441.35 191.93L441.35 192.88M441.35 192.88L440.96 193.75M440.96 193.75L440.26 194.38M440.26 194.38L439.36 194.68M439.36 194.68L438.41 194.58M438.41 194.58L437.59 194.1M437.59 194.1L437.03 193.34M437.03 193.34L436.83 192.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M437.8 190.12L440.44 190.12M440.44 190.12L441.75 192.41M441.75 192.41L440.44 194.69M440.44 194.69L437.8 194.69M437.8 194.69L436.48 192.41M436.48 192.41L437.8 190.12",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M437.93 192.41L438.12 191.76M438.12 191.76L438.62 191.33M438.62 191.33L439.29 191.23M439.29 191.23L439.89 191.51M439.89 191.51L440.26 192.07M440.26 192.07L440.26 192.74M440.26 192.74L439.89 193.3M439.89 193.3L439.29 193.58M439.29 193.58L438.62 193.49M438.62 193.49L438.12 193.05M438.12 193.05L437.93 192.41",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M431.57 183.29L431.77 182.36M431.77 182.36L432.33 181.59M432.33 181.59L433.15 181.12M433.15 181.12L434.09 181.02M434.09 181.02L435 181.31M435 181.31L435.7 181.95M435.7 181.95L436.09 182.82M436.09 182.82L436.09 183.77M436.09 183.77L435.7 184.63M435.7 184.63L435 185.27M435 185.27L434.09 185.56M434.09 185.56L433.15 185.46M433.15 185.46L432.33 184.99M432.33 184.99L431.77 184.22M431.77 184.22L431.57 183.29",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M432.54 181.01L435.17 181.01M435.17 181.01L436.49 183.29M436.49 183.29L435.17 185.57M435.17 185.57L432.54 185.57M432.54 185.57L431.22 183.29M431.22 183.29L432.54 181.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M432.67 183.29L432.86 182.65M432.86 182.65L433.36 182.21M433.36 182.21L434.02 182.12M434.02 182.12L434.63 182.39M434.63 182.39L434.99 182.96M434.99 182.96L434.99 183.62M434.99 183.62L434.63 184.19M434.63 184.19L434.02 184.46M434.02 184.46L433.36 184.37M433.36 184.37L432.86 183.93M432.86 183.93L432.67 183.29",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M412.47 195.64L438.93 180.36",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M414.55 187.84L425.53 206.84",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M431 178.35L441.97 197.35",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M448.68 127.57L448.68 130.91M448.68 132.88L448.68 136.82M448.68 138.79L448.68 142.72M448.68 144.69L448.68 148.63M448.68 150.6L448.68 153.94",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M463.46 155.96L463.46 125.4",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M467.71 127.57L467.71 130.91M467.71 132.88L467.71 136.82M467.71 138.79L467.71 142.72M467.71 144.69L467.71 148.63M467.71 150.6L467.71 153.94",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M448.68 127.57L451.3 127.57M453.27 127.57L457.21 127.57M459.18 127.57L463.11 127.57M465.08 127.57L467.71 127.57",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M448.68 153.94L451.3 153.94M453.27 153.94L457.21 153.94M459.18 153.94L463.11 153.94M465.08 153.94L467.71 153.94",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M461.17 150.25L461.37 149.32M461.37 149.32L461.93 148.55M461.93 148.55L462.75 148.08M462.75 148.08L463.69 147.98M463.69 147.98L464.6 148.27M464.6 148.27L465.3 148.91M465.3 148.91L465.69 149.78M465.69 149.78L465.69 150.73M465.69 150.73L465.3 151.59M465.3 151.59L464.6 152.23M464.6 152.23L463.69 152.52M463.69 152.52L462.75 152.42M462.75 152.42L461.93 151.95M461.93 151.95L461.37 151.18M461.37 151.18L461.17 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M460.82 150.25L462.14 152.53M462.14 152.53L464.77 152.53M464.77 152.53L466.09 150.25M466.09 150.25L464.77 147.97M464.77 147.97L462.14 147.97M462.14 147.97L460.82 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M462.27 150.25L462.46 149.61M462.46 149.61L462.96 149.17M462.96 149.17L463.62 149.08M463.62 149.08L464.23 149.35M464.23 149.35L464.59 149.92M464.59 149.92L464.59 150.59M464.59 150.59L464.23 151.15M464.23 151.15L463.62 151.43M463.62 151.43L462.96 151.33M462.96 151.33L462.46 150.89M462.46 150.89L462.27 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M450.65 150.25L450.84 149.32M450.84 149.32L451.4 148.55M451.4 148.55L452.22 148.08M452.22 148.08L453.17 147.98M453.17 147.98L454.07 148.27M454.07 148.27L454.78 148.91M454.78 148.91L455.16 149.78M455.16 149.78L455.16 150.73M455.16 150.73L454.78 151.59M454.78 151.59L454.07 152.23M454.07 152.23L453.17 152.52M453.17 152.52L452.22 152.42M452.22 152.42L451.4 151.95M451.4 151.95L450.84 151.18M450.84 151.18L450.65 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M450.29 150.25L451.61 152.53M451.61 152.53L454.25 152.53M454.25 152.53L455.57 150.25M455.57 150.25L454.25 147.97M454.25 147.97L451.61 147.97M451.61 147.97L450.29 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M451.74 150.25L451.93 149.61M451.93 149.61L452.44 149.17M452.44 149.17L453.1 149.08M453.1 149.08L453.71 149.35M453.71 149.35L454.07 149.92M454.07 149.92L454.07 150.59M454.07 150.59L453.71 151.15M453.71 151.15L453.1 151.43M453.1 151.43L452.44 151.33M452.44 151.33L451.93 150.89M451.93 150.89L451.74 150.25",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M461.17 131.26L461.37 130.33M461.37 130.33L461.93 129.56M461.93 129.56L462.75 129.09M462.75 129.09L463.69 128.99M463.69 128.99L464.6 129.28M464.6 129.28L465.3 129.92M465.3 129.92L465.69 130.79M465.69 130.79L465.69 131.74M465.69 131.74L465.3 132.6M465.3 132.6L464.6 133.24M464.6 133.24L463.69 133.53M463.69 133.53L462.75 133.43M462.75 133.43L461.93 132.96M461.93 132.96L461.37 132.19M461.37 132.19L461.17 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M460.82 131.26L462.14 128.98M462.14 128.98L464.77 128.98M464.77 128.98L466.09 131.26M466.09 131.26L464.77 133.55M464.77 133.55L462.14 133.55M462.14 133.55L460.82 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M462.27 131.26L462.46 130.62M462.46 130.62L462.96 130.18M462.96 130.18L463.62 130.09M463.62 130.09L464.23 130.36M464.23 130.36L464.59 130.93M464.59 130.93L464.59 131.6M464.59 131.6L464.23 132.16M464.23 132.16L463.62 132.44M463.62 132.44L462.96 132.34M462.96 132.34L462.46 131.9M462.46 131.9L462.27 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M450.65 131.26L450.84 130.33M450.84 130.33L451.4 129.56M451.4 129.56L452.22 129.09M452.22 129.09L453.17 128.99M453.17 128.99L454.07 129.28M454.07 129.28L454.78 129.92M454.78 129.92L455.16 130.79M455.16 130.79L455.16 131.74M455.16 131.74L454.78 132.6M454.78 132.6L454.07 133.24M454.07 133.24L453.17 133.53M453.17 133.53L452.22 133.43M452.22 133.43L451.4 132.96M451.4 132.96L450.84 132.19M450.84 132.19L450.65 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M450.29 131.26L451.61 128.98M451.61 128.98L454.25 128.98M454.25 128.98L455.57 131.26M455.57 131.26L454.25 133.55M454.25 133.55L451.61 133.55M451.61 133.55L450.29 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M451.74 131.26L451.93 130.62M451.93 130.62L452.44 130.18M452.44 130.18L453.1 130.09M453.1 130.09L453.71 130.36M453.71 130.36L454.07 130.93M454.07 130.93L454.07 131.6M454.07 131.6L453.71 132.16M453.71 132.16L453.1 132.44M453.1 132.44L452.44 132.34M452.44 132.34L451.93 131.9M451.93 131.9L451.74 131.26",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M452.93 155.96L452.93 125.4",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M447.22 150.25L469.16 150.25",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M447.22 131.26L469.16 131.26",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M412.09 90.56L414.98 92.23M416.69 93.22L420.1 95.19M421.8 96.17L425.21 98.14M426.92 99.12L430.33 101.09M432.03 102.08L434.93 103.75",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M444.06 91.96L417.59 76.68",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M421.6 74.08L424.5 75.76M426.2 76.74L429.61 78.71M431.31 79.69L434.72 81.66M436.43 82.65L439.84 84.62M441.54 85.6L444.44 87.27",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M412.09 90.56L413.4 88.29M414.38 86.59L416.35 83.18M417.34 81.47L419.3 78.06M420.29 76.36L421.6 74.08",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M434.93 103.75L436.24 101.48M437.22 99.77L439.19 96.36M440.17 94.66L442.14 91.25M443.13 89.54L444.44 87.27",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M436.83 89.11L437.03 88.18M437.03 88.18L437.59 87.41M437.59 87.41L438.41 86.93M438.41 86.93L439.36 86.83M439.36 86.83L440.26 87.13M440.26 87.13L440.96 87.76M440.96 87.76L441.35 88.63M441.35 88.63L441.35 89.58M441.35 89.58L440.96 90.45M440.96 90.45L440.26 91.08M440.26 91.08L439.36 91.38M439.36 91.38L438.41 91.28M438.41 91.28L437.59 90.8M437.59 90.8L437.03 90.03M437.03 90.03L436.83 89.11",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M437.8 91.39L440.44 91.39M440.44 91.39L441.75 89.11M441.75 89.11L440.44 86.82M440.44 86.82L437.8 86.82M437.8 86.82L436.48 89.11M436.48 89.11L437.8 91.39",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M437.93 89.11L438.12 88.46M438.12 88.46L438.62 88.03M438.62 88.03L439.29 87.93M439.29 87.93L439.89 88.21M439.89 88.21L440.26 88.77M440.26 88.77L440.26 89.44M440.26 89.44L439.89 90M439.89 90L439.29 90.28M439.29 90.28L438.62 90.19M438.62 90.19L438.12 89.75M438.12 89.75L437.93 89.11",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M431.57 98.22L431.77 97.29M431.77 97.29L432.33 96.52M432.33 96.52L433.15 96.05M433.15 96.05L434.09 95.95M434.09 95.95L435 96.24M435 96.24L435.7 96.88M435.7 96.88L436.09 97.75M436.09 97.75L436.09 98.7M436.09 98.7L435.7 99.56M435.7 99.56L435 100.2M435 100.2L434.09 100.49M434.09 100.49L433.15 100.39M433.15 100.39L432.33 99.92M432.33 99.92L431.77 99.15M431.77 99.15L431.57 98.22",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M432.54 100.51L435.17 100.51M435.17 100.51L436.49 98.22M436.49 98.22L435.17 95.94M435.17 95.94L432.54 95.94M432.54 95.94L431.22 98.22M431.22 98.22L432.54 100.51",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M432.67 98.22L432.86 97.58M432.86 97.58L433.36 97.14M433.36 97.14L434.02 97.05M434.02 97.05L434.63 97.33M434.63 97.33L434.99 97.89M434.99 97.89L434.99 98.56M434.99 98.56L434.63 99.12M434.63 99.12L434.02 99.4M434.02 99.4L433.36 99.3M433.36 99.3L432.86 98.86M432.86 98.86L432.67 98.22",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M420.39 79.61L420.59 78.68M420.59 78.68L421.14 77.91M421.14 77.91L421.97 77.44M421.97 77.44L422.91 77.34M422.91 77.34L423.81 77.63M423.81 77.63L424.52 78.27M424.52 78.27L424.91 79.14M424.91 79.14L424.91 80.09M424.91 80.09L424.52 80.95M424.52 80.95L423.81 81.59M423.81 81.59L422.91 81.88M422.91 81.88L421.97 81.78M421.97 81.78L421.14 81.31M421.14 81.31L420.59 80.54M420.59 80.54L420.39 79.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M421.35 81.9L420.03 79.61M420.03 79.61L421.35 77.33M421.35 77.33L423.99 77.33M423.99 77.33L425.31 79.61M425.31 79.61L423.99 81.9M423.99 81.9L421.35 81.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M421.49 79.61L421.67 78.97M421.67 78.97L422.18 78.53M422.18 78.53L422.84 78.44M422.84 78.44L423.45 78.71M423.45 78.71L423.81 79.28M423.81 79.28L423.81 79.95M423.81 79.95L423.45 80.51M423.45 80.51L422.84 80.79M422.84 80.79L422.18 80.69M422.18 80.69L421.67 80.25M421.67 80.25L421.49 79.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M415.12 88.73L415.32 87.8M415.32 87.8L415.88 87.03M415.88 87.03L416.7 86.56M416.7 86.56L417.65 86.46M417.65 86.46L418.55 86.75M418.55 86.75L419.26 87.38M419.26 87.38L419.64 88.25M419.64 88.25L419.64 89.2M419.64 89.2L419.26 90.07M419.26 90.07L418.55 90.71M418.55 90.71L417.65 91M417.65 91L416.7 90.9M416.7 90.9L415.88 90.42M415.88 90.42L415.32 89.66M415.32 89.66L415.12 88.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M416.09 91.01L414.77 88.73M414.77 88.73L416.09 86.44M416.09 86.44L418.73 86.44M418.73 86.44L420.05 88.73M420.05 88.73L418.73 91.01M418.73 91.01L416.09 91.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M416.22 88.73L416.41 88.09M416.41 88.09L416.92 87.65M416.92 87.65L417.58 87.55M417.58 87.55L418.19 87.83M418.19 87.83L418.55 88.39M418.55 88.39L418.55 89.06M418.55 89.06L418.19 89.62M418.19 89.62L417.58 89.9M417.58 89.9L416.92 89.81M416.92 89.81L416.41 89.37M416.41 89.37L416.22 88.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M438.8 101.08L412.33 85.8",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M431 103.17L441.97 84.16",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M414.55 93.67L425.53 74.67",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M361.74 103.75L364.64 102.08M366.34 101.09L369.75 99.12M371.46 98.14L374.87 96.17M376.57 95.19L379.98 93.22M381.68 92.23L384.58 90.56",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M378.94 76.76L352.47 92.04",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M352.23 87.27L355.12 85.6M356.83 84.62L360.24 82.65M361.94 81.66L365.35 79.69M367.06 78.71L370.47 76.74M372.17 75.76L375.07 74.08",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M361.74 103.75L360.43 101.48M359.44 99.77L357.48 96.36M356.49 94.66L354.52 91.25M353.54 89.54L352.23 87.27",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M384.58 90.56L383.27 88.29M382.28 86.59L380.32 83.18M379.33 81.47L377.36 78.06M376.38 76.36L375.07 74.08",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M371.71 79.61L371.91 78.68M371.91 78.68L372.47 77.91M372.47 77.91L373.29 77.44M373.29 77.44L374.23 77.34M374.23 77.34L375.14 77.63M375.14 77.63L375.84 78.27M375.84 78.27L376.23 79.14M376.23 79.14L376.23 80.09M376.23 80.09L375.84 80.95M375.84 80.95L375.14 81.59M375.14 81.59L374.23 81.88M374.23 81.88L373.29 81.78M373.29 81.78L372.47 81.31M372.47 81.31L371.91 80.54M371.91 80.54L371.71 79.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M375.31 81.9L376.63 79.61M376.63 79.61L375.31 77.33M375.31 77.33L372.68 77.33M372.68 77.33L371.36 79.61M371.36 79.61L372.68 81.9M372.68 81.9L375.31 81.9",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M372.81 79.61L373 78.97M373 78.97L373.5 78.53M373.5 78.53L374.16 78.44M374.16 78.44L374.77 78.71M374.77 78.71L375.13 79.28M375.13 79.28L375.13 79.95M375.13 79.95L374.77 80.51M374.77 80.51L374.16 80.79M374.16 80.79L373.5 80.69M373.5 80.69L373 80.25M373 80.25L372.81 79.61",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M376.97 88.73L377.17 87.8M377.17 87.8L377.73 87.03M377.73 87.03L378.55 86.56M378.55 86.56L379.5 86.46M379.5 86.46L380.4 86.75M380.4 86.75L381.11 87.38M381.11 87.38L381.49 88.25M381.49 88.25L381.49 89.2M381.49 89.2L381.11 90.07M381.11 90.07L380.4 90.71M380.4 90.71L379.5 91M379.5 91L378.55 90.9M378.55 90.9L377.73 90.42M377.73 90.42L377.17 89.66M377.17 89.66L376.97 88.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M380.58 91.01L381.9 88.73M381.9 88.73L380.58 86.44M380.58 86.44L377.94 86.44M377.94 86.44L376.62 88.73M376.62 88.73L377.94 91.01M377.94 91.01L380.58 91.01",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M378.07 88.73L378.26 88.09M378.26 88.09L378.77 87.65M378.77 87.65L379.43 87.55M379.43 87.55L380.03 87.83M380.03 87.83L380.4 88.39M380.4 88.39L380.4 89.06M380.4 89.06L380.03 89.62M380.03 89.62L379.43 89.9M379.43 89.9L378.77 89.81M378.77 89.81L378.26 89.37M378.26 89.37L378.07 88.73",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M355.27 89.11L355.46 88.18M355.46 88.18L356.02 87.41M356.02 87.41L356.84 86.93M356.84 86.93L357.79 86.83M357.79 86.83L358.69 87.13M358.69 87.13L359.4 87.76M359.4 87.76L359.78 88.63M359.78 88.63L359.78 89.58M359.78 89.58L359.4 90.45M359.4 90.45L358.69 91.08M358.69 91.08L357.79 91.38M357.79 91.38L356.84 91.28M356.84 91.28L356.02 90.8M356.02 90.8L355.46 90.03M355.46 90.03L355.27 89.11",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M358.87 91.39L356.23 91.39M356.23 91.39L354.91 89.11M354.91 89.11L356.23 86.82M356.23 86.82L358.87 86.82M358.87 86.82L360.19 89.11M360.19 89.11L358.87 91.39",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M356.36 89.11L356.55 88.46M356.55 88.46L357.06 88.03M357.06 88.03L357.72 87.93M357.72 87.93L358.33 88.21M358.33 88.21L358.69 88.77M358.69 88.77L358.69 89.44M358.69 89.44L358.33 90M358.33 90L357.72 90.28M357.72 90.28L357.06 90.19M357.06 90.19L356.55 89.75M356.55 89.75L356.36 89.11",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M360.53 98.22L360.73 97.29M360.73 97.29L361.28 96.52M361.28 96.52L362.11 96.05M362.11 96.05L363.05 95.95M363.05 95.95L363.95 96.24M363.95 96.24L364.66 96.88M364.66 96.88L365.05 97.75M365.05 97.75L365.05 98.7M365.05 98.7L364.66 99.56M364.66 99.56L363.95 100.2M363.95 100.2L363.05 100.49M363.05 100.49L362.11 100.39M362.11 100.39L361.28 99.92M361.28 99.92L360.73 99.15M360.73 99.15L360.53 98.22",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M364.13 100.51L361.49 100.51M361.49 100.51L360.18 98.22M360.18 98.22L361.49 95.94M361.49 95.94L364.13 95.94M364.13 95.94L365.45 98.22M365.45 98.22L364.13 100.51",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M361.63 98.22L361.81 97.58M361.81 97.58L362.32 97.14M362.32 97.14L362.98 97.05M362.98 97.05L363.59 97.33M363.59 97.33L363.95 97.89M363.95 97.89L363.95 98.56M363.95 98.56L363.59 99.12M363.59 99.12L362.98 99.4M362.98 99.4L362.32 99.3M362.32 99.3L361.81 98.86M361.81 98.86L361.63 98.22",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M384.2 85.87L357.74 101.15",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M382.11 93.67L371.14 74.67",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M365.67 103.17L354.7 84.16",
    fill: "none",
    stroke: "deepskyblue",
    strokeWidth: 0.5
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M374.62 140.76L374.82 139.83M374.82 139.83L375.38 139.06M375.38 139.06L376.2 138.58M376.2 138.58L377.14 138.48M377.14 138.48L378.05 138.78M378.05 138.78L378.75 139.41M378.75 139.41L379.14 140.28M379.14 140.28L379.14 141.23M379.14 141.23L378.75 142.1M378.75 142.1L378.05 142.73M378.05 142.73L377.14 143.03M377.14 143.03L376.2 142.93M376.2 142.93L375.38 142.45M375.38 142.45L374.82 141.69M374.82 141.69L374.62 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M379.54 140.76L378.22 138.47M378.22 138.47L375.59 138.47M375.59 138.47L374.27 140.76M374.27 140.76L375.59 143.04M375.59 143.04L378.22 143.04M378.22 143.04L379.54 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M375.72 140.76L375.91 140.11M375.91 140.11L376.41 139.68M376.41 139.68L377.07 139.58M377.07 139.58L377.68 139.86M377.68 139.86L378.04 140.42M378.04 140.42L378.04 141.09M378.04 141.09L377.68 141.65M377.68 141.65L377.07 141.93M377.07 141.93L376.41 141.84M376.41 141.84L375.91 141.4M375.91 141.4L375.72 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M385.34 159.31L385.53 158.38M385.53 158.38L386.09 157.62M386.09 157.62L386.91 157.14M386.91 157.14L387.86 157.04M387.86 157.04L388.76 157.34M388.76 157.34L389.47 157.97M389.47 157.97L389.85 158.84M389.85 158.84L389.85 159.79M389.85 159.79L389.47 160.66M389.47 160.66L388.76 161.29M388.76 161.29L387.86 161.58M387.86 161.58L386.91 161.49M386.91 161.49L386.09 161.01M386.09 161.01L385.53 160.24M385.53 160.24L385.34 159.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M388.94 157.03L386.3 157.03M386.3 157.03L384.98 159.31M384.98 159.31L386.3 161.6M386.3 161.6L388.94 161.6M388.94 161.6L390.26 159.31M390.26 159.31L388.94 157.03",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M386.43 159.31L386.62 158.67M386.62 158.67L387.13 158.23M387.13 158.23L387.79 158.14M387.79 158.14L388.4 158.42M388.4 158.42L388.76 158.98M388.76 158.98L388.76 159.65M388.76 159.65L388.4 160.21M388.4 160.21L387.79 160.49M387.79 160.49L387.13 160.39M387.13 160.39L386.62 159.95M386.62 159.95L386.43 159.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M406.76 159.31L406.96 158.38M406.96 158.38L407.52 157.62M407.52 157.62L408.34 157.14M408.34 157.14L409.29 157.04M409.29 157.04L410.19 157.34M410.19 157.34L410.89 157.97M410.89 157.97L411.28 158.84M411.28 158.84L411.28 159.79M411.28 159.79L410.89 160.66M410.89 160.66L410.19 161.29M410.19 161.29L409.29 161.58M409.29 161.58L408.34 161.49M408.34 161.49L407.52 161.01M407.52 161.01L406.96 160.24M406.96 160.24L406.76 159.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M407.73 157.03L406.41 159.31M406.41 159.31L407.73 161.6M407.73 161.6L410.37 161.6M410.37 161.6L411.68 159.31M411.68 159.31L410.37 157.03M410.37 157.03L407.73 157.03",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M407.86 159.31L408.05 158.67M408.05 158.67L408.55 158.23M408.55 158.23L409.22 158.14M409.22 158.14L409.82 158.42M409.82 158.42L410.19 158.98M410.19 158.98L410.19 159.65M410.19 159.65L409.82 160.21M409.82 160.21L409.22 160.49M409.22 160.49L408.55 160.39M408.55 160.39L408.05 159.95M408.05 159.95L407.86 159.31",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M417.48 140.76L417.67 139.83M417.67 139.83L418.23 139.06M418.23 139.06L419.06 138.58M419.06 138.58L420 138.48M420 138.48L420.9 138.78M420.9 138.78L421.61 139.41M421.61 139.41L421.99 140.28M421.99 140.28L421.99 141.23M421.99 141.23L421.61 142.1M421.61 142.1L420.9 142.73M420.9 142.73L420 143.03M420 143.03L419.06 142.93M419.06 142.93L418.23 142.45M418.23 142.45L417.67 141.69M417.67 141.69L417.48 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M417.12 140.76L418.44 143.04M418.44 143.04L421.08 143.04M421.08 143.04L422.4 140.76M422.4 140.76L421.08 138.47M421.08 138.47L418.44 138.47M418.44 138.47L417.12 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M418.57 140.76L418.76 140.11M418.76 140.11L419.27 139.68M419.27 139.68L419.93 139.58M419.93 139.58L420.54 139.86M420.54 139.86L420.9 140.42M420.9 140.42L420.9 141.09M420.9 141.09L420.54 141.65M420.54 141.65L419.93 141.93M419.93 141.93L419.27 141.84M419.27 141.84L418.76 141.4M418.76 141.4L418.57 140.76",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M406.76 122.2L406.96 121.27M406.96 121.27L407.52 120.5M407.52 120.5L408.34 120.03M408.34 120.03L409.29 119.93M409.29 119.93L410.19 120.22M410.19 120.22L410.89 120.86M410.89 120.86L411.28 121.72M411.28 121.72L411.28 122.67M411.28 122.67L410.89 123.54M410.89 123.54L410.19 124.18M410.19 124.18L409.29 124.47M409.29 124.47L408.34 124.37M408.34 124.37L407.52 123.9M407.52 123.9L406.96 123.13M406.96 123.13L406.76 122.2",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M407.73 124.48L410.37 124.48M410.37 124.48L411.68 122.2M411.68 122.2L410.37 119.92M410.37 119.92L407.73 119.92M407.73 119.92L406.41 122.2M406.41 122.2L407.73 124.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M407.86 122.2L408.05 121.56M408.05 121.56L408.55 121.12M408.55 121.12L409.22 121.02M409.22 121.02L409.82 121.3M409.82 121.3L410.19 121.86M410.19 121.86L410.19 122.53M410.19 122.53L409.82 123.1M409.82 123.1L409.22 123.37M409.22 123.37L408.55 123.28M408.55 123.28L408.05 122.84M408.05 122.84L407.86 122.2",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M385.34 122.2L385.53 121.27M385.53 121.27L386.09 120.5M386.09 120.5L386.91 120.03M386.91 120.03L387.86 119.93M387.86 119.93L388.76 120.22M388.76 120.22L389.47 120.86M389.47 120.86L389.85 121.72M389.85 121.72L389.85 122.67M389.85 122.67L389.47 123.54M389.47 123.54L388.76 124.18M388.76 124.18L387.86 124.47M387.86 124.47L386.91 124.37M386.91 124.37L386.09 123.9M386.09 123.9L385.53 123.13M385.53 123.13L385.34 122.2",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M388.94 124.48L390.26 122.2M390.26 122.2L388.94 119.92M388.94 119.92L386.3 119.92M386.3 119.92L384.98 122.2M384.98 122.2L386.3 124.48M386.3 124.48L388.94 124.48",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M386.43 122.2L386.62 121.56M386.62 121.56L387.13 121.12M387.13 121.12L387.79 121.02M387.79 121.02L388.4 121.3M388.4 121.3L388.76 121.86M388.76 121.86L388.76 122.53M388.76 122.53L388.4 123.1M388.4 123.1L387.79 123.37M387.79 123.37L387.13 123.28M387.13 123.28L386.62 122.84M386.62 122.84L386.43 122.2",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M439.35 69.71L432.78 81.09M430.82 84.5L428.85 87.91M426.88 91.32L417.03 108.36M415.07 111.77L413.1 115.18M411.13 118.59L401.29 135.64M399.32 139.05L397.35 142.46M395.38 145.87L385.54 162.92M383.57 166.33L381.6 169.74M379.63 173.15L369.79 190.2M367.82 193.61L365.85 197.02M363.88 200.43L357.31 211.81",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M403.68 279.21L399.36 275.55 404.63 277.62 403.68 279.21Z",
    fillRule: "nonzero",
    fill: "lime"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M404.15 278.42L482.27 325.11M482.27 325.11L618.06 325.11",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M488.59 318.91L488.59 311.47M493.55 311.47L488.59 316.43M490.36 314.66L493.55 318.91M496.03 318.91L496.03 311.47M496.03 311.47L500.63 311.47M496.03 315.01L498.86 315.01M496.03 318.91L500.63 318.91M502.76 311.47L505.59 315.01M505.59 315.01L508.43 311.47M505.59 315.01L505.59 318.91M516.58 311.47L518.35 318.91M518.35 318.91L520.12 311.47M520.12 311.47L521.89 318.91M521.89 318.91L523.66 311.47M525.08 318.91L527.91 311.47M527.91 311.47L530.75 318.91M526.14 316.43L529.69 316.43M532.87 311.47L535.71 315.01M535.71 315.01L538.54 311.47M535.71 315.01L535.71 318.91M549.17 310.05L548.46 310.76M548.46 310.76L547.75 311.82M547.75 311.82L547.05 313.24M547.05 313.24L546.69 315.01M546.69 315.01L546.69 316.43M546.69 316.43L547.05 318.2M547.05 318.2L547.75 319.62M547.75 319.62L548.46 320.68M548.46 320.68L549.17 321.39M551.65 311.47L553.42 318.91M553.42 318.91L555.2 311.47M555.2 311.47L556.97 318.91M556.97 318.91L558.74 311.47M566.89 318.91L570.78 313.95M570.78 318.91L566.89 313.95M579.64 318.91L579.64 311.47M579.64 311.47L582.12 311.47M582.12 311.47L583.19 311.82M583.19 311.82L583.89 312.53M583.89 312.53L584.25 313.24M584.25 313.24L584.6 314.3M584.6 314.3L584.6 316.07M584.6 316.07L584.25 317.14M584.25 317.14L583.89 317.84M583.89 317.84L583.19 318.55M583.19 318.55L582.12 318.91M582.12 318.91L579.64 318.91M593.81 318.91L597.71 313.95M597.71 318.91L593.81 313.95M606.57 311.47L606.57 318.91M606.57 318.91L610.82 318.91M612.59 310.05L613.3 310.76M613.3 310.76L614.01 311.82M614.01 311.82L614.72 313.24M614.72 313.24L615.07 315.01M615.07 315.01L615.07 316.43M615.07 316.43L614.72 318.2M614.72 318.2L614.01 319.62M614.01 319.62L613.3 320.68M613.3 320.68L612.59 321.39",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M391.23 289.09L391.23 303.05",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M405.27 289.09L405.27 303.05",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M385.03 299.33L378.83 299.33",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M411.47 299.33L417.67 299.33",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M392.92 312.72L392.92 305.28M392.92 305.28L395.4 305.28M395.4 305.28L396.47 305.64M396.47 305.64L397.17 306.35M397.17 306.35L397.53 307.05M397.53 307.05L397.88 308.12M397.88 308.12L397.88 309.89M397.88 309.89L397.53 310.95M397.53 310.95L397.17 311.66M397.17 311.66L396.47 312.37M396.47 312.37L395.4 312.72M395.4 312.72L392.92 312.72M402.13 306.7L401.43 307.05M401.43 307.05L400.72 307.76M400.72 307.76L400.36 308.83M400.36 308.83L400.36 309.53M400.36 309.53L400.72 310.6M400.72 310.6L401.43 311.31M401.43 311.31L402.13 311.66M402.13 311.66L403.2 311.66M403.2 311.66L403.91 311.31M403.91 311.31L404.61 310.6M404.61 310.6L404.97 309.53M404.97 309.53L404.97 308.83M404.97 308.83L404.61 307.76M404.61 307.76L403.91 307.05M403.91 307.05L403.2 306.7M403.2 306.7L402.13 306.7M404.26 305.64L401.07 312.72",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M391.23 299.33L405.27 299.33",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M385.03 298.29L391.23 299.33 391.23 299.33 385.03 300.36 385.03 298.29Z",
    fillRule: "evenodd",
    fill: "lime"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M411.47 298.29L405.27 299.33 405.27 299.33 411.47 300.36 411.47 298.29Z",
    fillRule: "evenodd",
    fill: "lime"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M391.23 285.37L391.23 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M405.27 285.37L405.27 285.37",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M405.27 299.33L405.27 299.33",
    fill: "none",
    stroke: "blue",
    strokeWidth: 0.5
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M488.59 337.4L488.59 329.96M488.59 329.96L491.07 329.96M491.07 329.96L492.13 330.32M492.13 330.32L492.84 331.02M492.84 331.02L493.19 331.73M493.19 331.73L493.55 332.8M493.55 332.8L493.55 334.57M493.55 334.57L493.19 335.63M493.19 335.63L492.84 336.34M492.84 336.34L492.13 337.05M492.13 337.05L491.07 337.4M491.07 337.4L488.59 337.4M496.03 337.4L496.03 329.96M498.86 337.4L498.86 329.96M498.86 329.96L501.7 337.4M501.7 337.4L504.53 329.96M504.53 329.96L504.53 337.4M507.36 337.4L507.36 329.96M507.36 329.96L511.97 329.96M507.36 333.5L510.2 333.5M507.36 337.4L511.97 337.4M514.1 337.4L514.1 329.96M514.1 329.96L519.06 337.4M519.06 337.4L519.06 329.96M526.85 331.02L526.14 330.32M526.14 330.32L525.08 329.96M525.08 329.96L523.66 329.96M523.66 329.96L522.6 330.32M522.6 330.32L521.89 331.02M521.89 331.02L521.89 331.73M521.89 331.73L522.24 332.44M522.24 332.44L522.6 332.8M522.6 332.8L523.31 333.15M523.31 333.15L525.43 333.86M525.43 333.86L526.14 334.21M526.14 334.21L526.5 334.57M526.5 334.57L526.85 335.28M526.85 335.28L526.85 336.34M526.85 336.34L526.14 337.05M526.14 337.05L525.08 337.4M525.08 337.4L523.66 337.4M523.66 337.4L522.6 337.05M522.6 337.05L521.89 336.34M528.98 337.4L528.98 329.96M533.94 329.96L533.23 330.32M533.23 330.32L532.52 331.02M532.52 331.02L532.17 331.73M532.17 331.73L531.81 332.8M531.81 332.8L531.81 334.57M531.81 334.57L532.17 335.63M532.17 335.63L532.52 336.34M532.52 336.34L533.23 337.05M533.23 337.05L533.94 337.4M533.94 337.4L535.35 337.4M535.35 337.4L536.06 337.05M536.06 337.05L536.77 336.34M536.77 336.34L537.13 335.63M537.13 335.63L537.48 334.57M537.48 334.57L537.48 332.8M537.48 332.8L537.13 331.73M537.13 331.73L536.77 331.02M536.77 331.02L536.06 330.32M536.06 330.32L535.35 329.96M535.35 329.96L533.94 329.96M539.61 337.4L539.61 329.96M539.61 329.96L544.57 337.4M544.57 337.4L544.57 329.96M552.36 331.02L551.65 330.32M551.65 330.32L550.59 329.96M550.59 329.96L549.17 329.96M549.17 329.96L548.11 330.32M548.11 330.32L547.4 331.02M547.4 331.02L547.4 331.73M547.4 331.73L547.75 332.44M547.75 332.44L548.11 332.8M548.11 332.8L548.82 333.15M548.82 333.15L550.94 333.86M550.94 333.86L551.65 334.21M551.65 334.21L552.01 334.57M552.01 334.57L552.36 335.28M552.36 335.28L552.36 336.34M552.36 336.34L551.65 337.05M551.65 337.05L550.59 337.4M550.59 337.4L549.17 337.4M549.17 337.4L548.11 337.05M548.11 337.05L547.4 336.34M566.18 331.02L565.47 330.32M565.47 330.32L564.41 329.96M564.41 329.96L562.99 329.96M562.99 329.96L561.93 330.32M561.93 330.32L561.22 331.02M561.22 331.02L561.22 331.73M561.22 331.73L561.57 332.44M561.57 332.44L561.93 332.8M561.93 332.8L562.64 333.15M562.64 333.15L564.76 333.86M564.76 333.86L565.47 334.21M565.47 334.21L565.82 334.57M565.82 334.57L566.18 335.28M566.18 335.28L566.18 336.34M566.18 336.34L565.47 337.05M565.47 337.05L564.41 337.4M564.41 337.4L562.99 337.4M562.99 337.4L561.93 337.05M561.93 337.05L561.22 336.34M568.3 329.96L568.3 335.28M568.3 335.28L568.66 336.34M568.66 336.34L569.37 337.05M569.37 337.05L570.43 337.4M570.43 337.4L571.14 337.4M571.14 337.4L572.2 337.05M572.2 337.05L572.91 336.34M572.91 336.34L573.26 335.28M573.26 335.28L573.26 329.96M576.1 337.4L576.1 329.96M581.41 329.96L581.41 337.4M578.93 329.96L583.89 329.96M585.31 337.4L588.15 329.96M588.15 329.96L590.98 337.4M586.37 334.92L589.92 334.92M593.11 337.4L593.11 329.96M593.11 329.96L596.29 329.96M596.29 329.96L597.36 330.32M597.36 330.32L597.71 330.67M597.71 330.67L598.07 331.38M598.07 331.38L598.07 332.09M598.07 332.09L597.71 332.8M597.71 332.8L597.36 333.15M597.36 333.15L596.29 333.5M593.11 333.5L596.29 333.5M596.29 333.5L597.36 333.86M597.36 333.86L597.71 334.21M597.71 334.21L598.07 334.92M598.07 334.92L598.07 335.98M598.07 335.98L597.71 336.69M597.71 336.69L597.36 337.05M597.36 337.05L596.29 337.4M596.29 337.4L593.11 337.4M600.55 329.96L600.55 337.4M600.55 337.4L604.8 337.4M606.57 337.4L606.57 329.96M606.57 329.96L611.18 329.96M606.57 333.5L609.4 333.5M606.57 337.4L611.18 337.4M620.03 337.4L622.87 329.96M622.87 329.96L625.7 337.4M621.1 334.92L624.64 334.92M632.79 331.02L632.08 330.32M632.08 330.32L631.02 329.96M631.02 329.96L629.6 329.96M629.6 329.96L628.54 330.32M628.54 330.32L627.83 331.02M627.83 331.02L627.83 331.73M627.83 331.73L628.18 332.44M628.18 332.44L628.54 332.8M628.54 332.8L629.24 333.15M629.24 333.15L631.37 333.86M631.37 333.86L632.08 334.21M632.08 334.21L632.43 334.57M632.43 334.57L632.79 335.28M632.79 335.28L632.79 336.34M632.79 336.34L632.08 337.05M632.08 337.05L631.02 337.4M631.02 337.4L629.6 337.4M629.6 337.4L628.54 337.05M628.54 337.05L627.83 336.34M641.65 337.4L641.65 329.96M641.65 329.96L644.83 329.96M644.83 329.96L645.9 330.32M645.9 330.32L646.25 330.67M646.25 330.67L646.61 331.38M646.61 331.38L646.61 332.44M646.61 332.44L646.25 333.15M646.25 333.15L645.9 333.5M645.9 333.5L644.83 333.86M644.83 333.86L641.65 333.86M649.09 337.4L649.09 329.96M649.09 329.96L653.69 329.96M649.09 333.5L651.92 333.5M649.09 337.4L653.69 337.4M655.82 337.4L655.82 329.96M655.82 329.96L659.01 329.96M659.01 329.96L660.07 330.32M660.07 330.32L660.42 330.67M660.42 330.67L660.78 331.38M660.78 331.38L660.78 332.09M660.78 332.09L660.42 332.8M660.42 332.8L660.07 333.15M660.07 333.15L659.01 333.5M659.01 333.5L655.82 333.5M658.3 333.5L660.78 337.4M669.99 337.4L669.99 329.96M669.99 329.96L674.6 329.96M669.99 333.5L672.82 333.5M669.99 337.4L674.6 337.4M676.72 337.4L681.68 329.96M676.72 329.96L681.68 337.4M683.81 337.4L683.81 329.96M691.6 331.02L690.89 330.32M690.89 330.32L689.83 329.96M689.83 329.96L688.41 329.96M688.41 329.96L687.35 330.32M687.35 330.32L686.64 331.02M686.64 331.02L686.64 331.73M686.64 331.73L687 332.44M687 332.44L687.35 332.8M687.35 332.8L688.06 333.15M688.06 333.15L690.18 333.86M690.18 333.86L690.89 334.21M690.89 334.21L691.25 334.57M691.25 334.57L691.6 335.28M691.6 335.28L691.6 336.34M691.6 336.34L690.89 337.05M690.89 337.05L689.83 337.4M689.83 337.4L688.41 337.4M688.41 337.4L687.35 337.05M687.35 337.05L686.64 336.34M696.21 329.96L696.21 337.4M693.73 329.96L698.69 329.96M700.11 337.4L700.11 329.96M702.94 337.4L702.94 329.96M702.94 329.96L707.9 337.4M707.9 337.4L707.9 329.96M716.05 331.73L715.69 331.02M715.69 331.02L714.99 330.32M714.99 330.32L714.28 329.96M714.28 329.96L712.86 329.96M712.86 329.96L712.15 330.32M712.15 330.32L711.44 331.02M711.44 331.02L711.09 331.73M711.09 331.73L710.73 332.8M710.73 332.8L710.73 334.57M710.73 334.57L711.09 335.63M711.09 335.63L711.44 336.34M711.44 336.34L712.15 337.05M712.15 337.05L712.86 337.4M712.86 337.4L714.28 337.4M714.28 337.4L714.99 337.05M714.99 337.05L715.69 336.34M715.69 336.34L716.05 335.63M716.05 335.63L716.05 334.57M716.05 334.57L714.28 334.57M730.22 331.73L729.87 331.02M729.87 331.02L729.16 330.32M729.16 330.32L728.45 329.96M728.45 329.96L727.03 329.96M727.03 329.96L726.32 330.32M726.32 330.32L725.61 331.02M725.61 331.02L725.26 331.73M725.26 331.73L724.91 332.8M724.91 332.8L724.91 334.57M724.91 334.57L725.26 335.63M725.26 335.63L725.61 336.34M725.61 336.34L726.32 337.05M726.32 337.05L727.03 337.4M727.03 337.4L728.45 337.4M728.45 337.4L729.16 337.05M729.16 337.05L729.87 336.34M729.87 336.34L730.22 335.63M730.22 335.63L730.22 334.57M730.22 334.57L728.45 334.57M732.35 337.4L732.35 329.96M732.35 329.96L736.95 329.96M732.35 333.5L735.18 333.5M732.35 337.4L736.95 337.4M739.08 337.4L741.91 329.96M741.91 329.96L744.75 337.4M740.14 334.92L743.68 334.92M746.87 337.4L746.87 329.96M746.87 329.96L750.06 329.96M750.06 329.96L751.12 330.32M751.12 330.32L751.48 330.67M751.48 330.67L751.83 331.38M751.83 331.38L751.83 332.09M751.83 332.09L751.48 332.8M751.48 332.8L751.12 333.15M751.12 333.15L750.06 333.5M750.06 333.5L746.87 333.5M749.35 333.5L751.83 337.4M754.31 337.4L754.31 329.96M754.31 329.96L757.5 329.96M757.5 329.96L758.57 330.32M758.57 330.32L758.92 330.67M758.92 330.67L759.27 331.38M759.27 331.38L759.27 332.09M759.27 332.09L758.92 332.8M758.92 332.8L758.57 333.15M758.57 333.15L757.5 333.5M754.31 333.5L757.5 333.5M757.5 333.5L758.57 333.86M758.57 333.86L758.92 334.21M758.92 334.21L759.27 334.92M759.27 334.92L759.27 335.98M759.27 335.98L758.92 336.69M758.92 336.69L758.57 337.05M758.57 337.05L757.5 337.4M757.5 337.4L754.31 337.4M763.88 329.96L763.17 330.32M763.17 330.32L762.46 331.02M762.46 331.02L762.11 331.73M762.11 331.73L761.75 332.8M761.75 332.8L761.75 334.57M761.75 334.57L762.11 335.63M762.11 335.63L762.46 336.34M762.46 336.34L763.17 337.05M763.17 337.05L763.88 337.4M763.88 337.4L765.3 337.4M765.3 337.4L766.01 337.05M766.01 337.05L766.71 336.34M766.71 336.34L767.07 335.63M767.07 335.63L767.42 334.57M767.42 334.57L767.42 332.8M767.42 332.8L767.07 331.73M767.07 331.73L766.71 331.02M766.71 331.02L766.01 330.32M766.01 330.32L765.3 329.96M765.3 329.96L763.88 329.96M769.55 337.4L774.51 329.96M769.55 329.96L774.51 337.4",
    fill: "none",
    stroke: "fuchsia",
    strokeWidth: 0.5
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M357.31 69.71L363.88 81.09M365.85 84.5L367.82 87.91M369.79 91.32L379.63 108.36M381.6 111.77L383.57 115.18M385.54 118.59L395.38 135.64M397.35 139.05L399.32 142.46M401.29 145.87L411.13 162.92M413.1 166.33L415.07 169.74M417.03 173.15L426.88 190.2M428.85 193.61L430.82 197.02M432.78 200.43L439.35 211.81",
    fill: "none",
    stroke: "lime",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGa6VDC);
export default __webpack_public_path__ + "static/media/GA-6-V-D-C.fbce8605c46a5c42f3ef8fcfae430369.svg";
export { ForwardRef as ReactComponent };